var _rect, _defs, _rect2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _polyline, _line22, _polyline2, _line23, _polyline3, _polyline4, _line24, _line25, _polyline5, _line26, _line27, _polyline6, _polyline7, _line28, _line29, _line30, _polyline8, _line31, _line32, _line33, _polyline9, _polyline10, _line34, _line35, _line36, _polyline11, _polyline12, _line37, _line38, _polyline13, _polyline14, _line39, _line40, _line41, _polyline15, _line42, _line43, _line44, _polyline16, _polyline17, _line45, _line46, _polyline18, _polyline19, _polyline20, _line47, _line48, _polyline21, _polyline22, _line49, _line50, _line51, _polyline23, _line52, _line53, _line54, _polyline24, _polyline25, _line55, _line56, _polyline26, _polyline27, _line57, _line58, _line59, _polyline28, _polyline29, _line60, _polyline30, _line61, _polyline31, _polyline32, _line62, _line63, _polyline33, _line64, _line65, _polyline34, _polyline35, _line66, _polyline36, _line67, _polyline37, _polyline38, _line68, _line69, _polyline39, _line70, _line71, _polyline40, _polyline41, _line72, _line73, _line74, _polyline42, _line75, _line76, _polyline43, _polyline44, _line77, _line78, _line79, _polyline45, _line80, _polyline46, _line81, _line82, _line83, _line84, _line85, _line86, _line87, _line88, _line89, _line90, _line91, _line92, _line93, _line94, _line95, _polyline47, _line96, _line97, _line98, _polyline48, _polyline49, _line99, _polyline50, _line100, _polyline51, _line101, _polyline52, _line102, _line103, _line104, _polyline53, _polyline54, _line105, _polyline55, _line106, _polyline56, _polyline57, _line107, _polyline58, _line108, _polyline59, _polyline60, _line109, _line110, _line111, _polyline61, _line112, _line113, _line114, _polyline62, _polyline63, _line115, _line116, _line117, _polyline64, _line118, _line119, _line120, _polyline65, _polyline66, _line121, _line122, _line123, _polyline67, _line124, _line125, _line126, _polyline68, _polyline69, _line127, _polyline70, _line128, _polyline71, _polyline72, _line129, _line130, _polyline73, _line131, _line132, _line133, _polyline74, _line134, _line135, _line136, _line137, _line138, _line139, _line140, _line141, _line142, _line143, _line144, _line145, _line146, _line147, _line148, _line149, _line150, _line151, _line152, _line153, _line154, _line155, _line156, _line157, _line158, _line159, _line160, _line161, _line162, _line163, _line164, _line165, _line166, _line167, _line168, _line169, _line170, _line171, _line172, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _line173, _line174, _line175, _line176, _polygon, _line177, _line178, _line179, _line180, _line181, _line182, _line183, _line184, _line185, _line186, _line187, _line188, _line189, _line190, _line191, _line192, _line193, _line194, _line195, _line196, _line197, _line198, _line199, _line200, _line201, _line202, _line203, _line204, _line205, _line206, _line207, _line208, _line209, _line210, _line211, _line212, _line213, _line214, _line215, _line216, _line217, _line218, _line219, _line220, _line221, _line222, _line223, _line224, _line225, _line226, _line227, _polyline75, _line228, _polyline76, _polyline77, _line229, _line230, _line231, _line232, _line233, _line234, _line235, _line236, _line237, _line238, _line239, _line240, _line241, _line242, _line243, _line244, _line245, _line246, _line247, _line248, _line249, _line250, _line251, _line252, _line253, _line254, _line255, _line256, _line257, _line258, _line259, _line260, _line261, _line262, _line263, _line264, _line265, _line266, _line267, _line268, _line269, _line270, _line271, _line272, _line273, _line274, _line275, _line276, _line277, _line278, _line279, _line280, _line281, _line282, _line283, _line284, _line285, _line286, _line287, _line288, _line289, _line290, _line291, _line292, _line293, _line294, _line295, _line296, _line297, _line298, _line299, _line300, _line301, _line302, _line303, _line304, _line305, _line306, _line307, _line308, _line309, _line310, _line311, _line312, _line313, _line314, _line315, _line316, _line317, _line318, _line319, _line320, _line321, _line322, _line323, _line324, _line325, _line326, _line327, _line328, _line329, _line330, _line331, _line332, _line333, _line334, _line335, _line336, _line337, _line338, _line339, _line340, _line341, _line342, _line343, _line344, _line345, _line346, _line347, _line348, _line349, _line350, _line351, _line352, _line353, _line354, _line355, _line356, _line357, _line358, _line359, _polyline78, _line360, _polyline79, _polyline80, _line361, _line362, _line363, _line364, _line365, _line366, _line367, _line368, _line369, _line370, _line371, _line372, _line373, _line374, _line375, _line376, _line377, _line378, _line379, _line380, _line381, _line382, _line383, _line384, _line385, _line386, _polyline81, _line387, _polyline82, _polyline83, _line388, _line389, _polyline84, _line390, _line391, _line392, _line393, _line394, _line395, _line396, _line397, _line398, _line399, _line400, _line401, _line402, _line403, _line404, _line405, _line406, _line407, _line408, _line409, _line410, _line411, _line412, _polyline85, _line413, _polyline86, _polyline87, _line414, _line415, _line416, _line417, _line418, _line419, _line420, _line421, _line422, _line423, _line424, _line425, _line426, _line427, _line428, _line429, _line430, _line431, _line432, _line433, _line434, _line435, _line436, _line437, _line438, _line439, _polyline88, _line440, _polyline89, _polyline90, _line441, _line442, _polyline91, _line443, _line444, _line445, _line446, _line447, _line448, _line449, _line450, _line451, _line452, _line453, _line454, _line455, _line456, _line457, _line458, _line459, _line460, _line461, _line462, _line463, _line464, _line465, _polyline92, _line466, _polyline93, _line467, _line468, _line469, _polyline94, _line470, _line471, _line472, _line473, _line474, _line475, _line476, _line477, _line478, _line479, _line480, _line481, _line482, _line483, _line484, _line485, _line486, _line487, _line488, _line489, _line490, _line491, _line492, _line493, _line494, _polyline95, _polyline96, _line495, _line496, _line497, _line498, _line499, _line500, _line501, _line502, _line503, _line504, _line505, _line506, _line507, _line508, _line509, _line510, _line511, _line512, _line513, _line514, _line515, _line516, _line517, _line518, _line519, _line520, _line521, _line522, _line523, _polyline97, _line524, _line525, _polyline98, _line526, _line527, _line528, _line529, _line530, _line531, _line532, _line533, _line534, _line535, _line536, _line537, _line538, _line539, _line540, _line541, _line542, _line543, _line544, _line545, _line546, _line547, _line548, _polyline99, _line549, _polyline100, _line550, _line551, _line552, _line553, _line554, _line555, _line556, _line557, _line558, _line559, _line560, _line561, _line562, _line563, _line564, _line565, _line566, _line567, _line568, _line569, _line570, _line571, _line572, _line573, _line574, _line575, _line576, _line577, _line578, _line579, _polyline101, _line580, _line581, _polyline102, _line582, _line583, _line584, _line585, _line586, _line587, _line588, _line589, _line590, _line591, _line592, _line593, _line594, _line595, _line596, _line597, _line598, _line599, _line600, _line601, _line602, _line603, _line604, _line605, _line606, _line607, _polyline103, _line608, _line609, _polyline104, _line610, _line611, _line612, _line613, _line614, _line615, _line616, _line617, _line618, _line619, _line620, _line621, _line622, _line623, _line624, _line625, _line626, _line627, _line628, _line629, _line630, _line631, _line632, _line633, _line634, _line635, _polyline105, _line636, _line637, _polyline106, _line638, _line639, _line640, _line641, _line642, _line643, _line644, _line645, _line646, _line647, _line648, _line649, _line650, _line651, _line652, _line653, _line654, _line655, _line656, _line657, _line658, _line659, _line660, _line661, _line662, _polyline107, _polyline108, _line663, _line664, _line665, _line666, _line667, _line668, _line669, _line670, _line671, _line672, _line673, _line674, _line675, _line676, _line677, _line678, _line679, _line680, _line681, _line682, _line683, _line684, _line685, _line686, _line687, _line688, _line689, _line690, _line691, _polyline109, _line692, _line693, _polyline110, _line694, _line695, _line696, _line697, _line698, _line699, _line700, _line701, _line702, _line703, _line704, _line705, _line706, _line707, _line708, _line709, _line710, _line711, _line712, _line713, _line714, _line715, _line716, _line717, _line718, _line719, _polyline111, _line720, _line721, _polyline112, _line722, _line723, _line724, _line725, _line726, _line727, _line728, _line729, _line730, _line731, _line732, _line733, _line734, _line735, _line736, _line737, _line738, _line739, _line740, _line741, _line742, _line743, _line744, _line745, _line746, _line747, _polyline113, _line748, _line749, _polyline114, _line750, _line751, _line752, _line753, _line754, _line755, _line756, _line757, _line758, _line759, _line760, _line761, _line762, _line763, _line764, _line765, _line766, _line767, _line768, _line769, _line770, _line771, _line772, _line773, _line774, _line775, _polyline115, _line776, _line777, _polyline116, _line778, _line779, _line780, _line781, _line782, _line783, _line784, _line785, _line786, _line787, _line788, _line789, _line790, _line791, _line792, _line793, _line794, _line795, _line796, _line797, _line798, _line799, _line800, _polyline117, _line801, _polyline118, _line802, _line803, _line804, _line805, _line806, _line807, _line808, _line809, _line810, _line811, _line812, _line813, _line814, _line815, _line816, _line817, _line818, _line819, _line820, _line821, _line822, _line823, _line824, _line825, _line826, _line827, _line828, _line829, _line830, _line831, _polyline119, _line832, _line833, _polyline120, _line834, _line835, _line836, _line837, _line838, _line839, _line840, _line841, _line842, _line843, _line844, _line845, _line846, _line847, _line848, _line849, _line850, _line851, _line852, _line853, _line854, _line855, _line856, _line857, _line858, _polyline121, _polyline122, _line859, _line860, _line861, _line862, _line863, _line864, _line865, _line866, _line867, _line868, _line869, _line870, _line871, _line872, _line873, _line874, _line875, _line876, _rect10, _line877, _line878;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNamiMapsCpSubArea1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1224 792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linecap: square;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-linejoin: round;\n        stroke-width: .75px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 981.11,
    y: 405.85,
    width: 2.27,
    height: 2.04
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 934.45,
    y1: 493.3,
    x2: 934.67,
    y2: 493.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 934.45,
    y1: 496.41,
    x2: 934.67,
    y2: 496.41
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 934.67,
    y1: 496.41,
    x2: 935.05,
    y2: 496.41
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 934.67,
    y1: 493.3,
    x2: 935.05,
    y2: 493.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 934.45,
    y1: 310.47,
    x2: 934.67,
    y2: 310.47
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 934.67,
    y1: 310.47,
    x2: 935.05,
    y2: 310.47
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 460.23,
    y1: 493.3,
    x2: 460.61,
    y2: 493.3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 460.23,
    y1: 496.41,
    x2: 460.61,
    y2: 496.41
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 460.61,
    y1: 496.41,
    x2: 460.76,
    y2: 496.41
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 460.61,
    y1: 493.3,
    x2: 460.76,
    y2: 493.3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 460.23,
    y1: 310.47,
    x2: 460.61,
    y2: 310.47
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 460.61,
    y1: 310.47,
    x2: 460.76,
    y2: 310.47
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 341.79,
    y1: 493.3,
    x2: 341.94,
    y2: 493.3
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 341.79,
    y1: 496.41,
    x2: 341.94,
    y2: 496.41
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 341.94,
    y1: 496.41,
    x2: 342.32,
    y2: 496.41
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 341.94,
    y1: 493.3,
    x2: 342.32,
    y2: 493.3
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 341.79,
    y1: 310.47,
    x2: 341.94,
    y2: 310.47
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 341.94,
    y1: 310.47,
    x2: 342.32,
    y2: 310.47
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 223.27,
    y1: 310.47,
    x2: 223.65,
    y2: 310.47
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 223.27,
    y1: 496.41,
    x2: 223.65,
    y2: 496.41
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 223.27,
    y1: 493.3,
    x2: 223.65,
    y2: 493.3
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "936.34 492.93 932.78 492.93 932.78 493.3 934.45 493.3"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 934.45,
    y1: 493.3,
    x2: 934.45,
    y2: 496.41
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "934.45 496.41 932.78 496.41 932.78 496.63 936.34 496.63 936.34 496.41 934.67 496.41"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 934.67,
    y1: 496.41,
    x2: 934.67,
    y2: 493.3
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "934.67 493.3 936.34 493.3 936.34 492.93"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "936.34 310.1 932.78 310.1 932.78 310.47 934.45 310.47"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 934.45,
    y1: 310.47,
    x2: 934.45,
    y2: 313.21
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 934.45,
    y1: 313.58,
    x2: 934.45,
    y2: 313.21
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "934.45 313.58 932.78 313.58 932.78 313.81 936.34 313.81 936.34 313.58 934.67 313.58"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 934.67,
    y1: 313.21,
    x2: 934.67,
    y2: 313.58
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 934.67,
    y1: 313.21,
    x2: 934.67,
    y2: 310.47
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "934.67 310.47 936.34 310.47 936.34 310.1"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "817.67 492.93 814.27 492.93 814.27 493.3 815.78 493.3"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 816.16,
    y1: 493.3,
    x2: 815.78,
    y2: 493.3
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 816.16,
    y1: 493.3,
    x2: 816.16,
    y2: 496.41
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 815.78,
    y1: 496.41,
    x2: 816.16,
    y2: 496.41
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "815.78 496.41 814.27 496.41 814.27 496.63 817.67 496.63 817.67 496.41 816.39 496.41"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 816.16,
    y1: 496.41,
    x2: 816.39,
    y2: 496.41
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 816.16,
    y1: 496.41,
    x2: 816.16,
    y2: 493.3
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 816.39,
    y1: 493.3,
    x2: 816.16,
    y2: 493.3
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "816.39 493.3 817.67 493.3 817.67 492.93"
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "817.67 310.1 814.27 310.1 814.27 310.47 815.78 310.47"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 816.16,
    y1: 310.47,
    x2: 815.78,
    y2: 310.47
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 816.16,
    y1: 310.47,
    x2: 816.16,
    y2: 313.21
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 815.78,
    y1: 313.58,
    x2: 816.16,
    y2: 313.21
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "815.78 313.58 814.27 313.58 814.27 313.81 817.67 313.81 817.67 313.58 816.39 313.58"
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "816.16 313.21 816.16 313.58 816.39 313.58"
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 816.16,
    y1: 313.21,
    x2: 816.16,
    y2: 310.47
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 816.39,
    y1: 310.47,
    x2: 816.16,
    y2: 310.47
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "816.39 310.47 817.67 310.47 817.67 310.1"
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "699.46 492.93 695.68 492.93 695.68 493.3 697.34 493.3"
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.57,
    y1: 493.3,
    x2: 697.34,
    y2: 493.3
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.57,
    y1: 493.3,
    x2: 697.57,
    y2: 496.41
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.34,
    y1: 496.41,
    x2: 697.57,
    y2: 496.41
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "697.34 496.41 695.68 496.41 695.68 496.63 699.46 496.63 699.46 496.41 697.72 496.41"
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.57,
    y1: 496.41,
    x2: 697.72,
    y2: 496.41
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.57,
    y1: 496.41,
    x2: 697.57,
    y2: 493.3
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.72,
    y1: 493.3,
    x2: 697.57,
    y2: 493.3
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "697.72 493.3 699.46 493.3 699.46 492.93"
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "699.46 310.1 695.68 310.1 695.68 310.47 697.34 310.47"
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.57,
    y1: 310.47,
    x2: 697.34,
    y2: 310.47
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.57,
    y1: 310.47,
    x2: 697.57,
    y2: 313.21
  })), _polyline18 || (_polyline18 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "697.34 313.58 697.57 313.58 697.57 313.21"
  })), _polyline19 || (_polyline19 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "697.34 313.58 695.68 313.58 695.68 313.81 699.46 313.81 699.46 313.58 697.72 313.58"
  })), _polyline20 || (_polyline20 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "697.57 313.21 697.57 313.58 697.72 313.58"
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.57,
    y1: 313.21,
    x2: 697.57,
    y2: 310.47
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.72,
    y1: 310.47,
    x2: 697.57,
    y2: 310.47
  })), _polyline21 || (_polyline21 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "697.72 310.47 699.46 310.47 699.46 310.1"
  })), _polyline22 || (_polyline22 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "580.79 492.93 577.39 492.93 577.39 493.3 578.67 493.3"
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 578.9,
    y1: 493.3,
    x2: 578.67,
    y2: 493.3
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 578.9,
    y1: 493.3,
    x2: 578.9,
    y2: 496.41
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 578.67,
    y1: 496.41,
    x2: 578.9,
    y2: 496.41
  })), _polyline23 || (_polyline23 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "578.67 496.41 577.39 496.41 577.39 496.63 580.79 496.63 580.79 496.41 579.28 496.41"
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 578.9,
    y1: 496.41,
    x2: 579.28,
    y2: 496.41
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 578.9,
    y1: 496.41,
    x2: 578.9,
    y2: 493.3
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 579.28,
    y1: 493.3,
    x2: 578.9,
    y2: 493.3
  })), _polyline24 || (_polyline24 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "579.28 493.3 580.79 493.3 580.79 492.93"
  })), _polyline25 || (_polyline25 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "580.79 310.1 577.39 310.1 577.39 310.47 578.67 310.47"
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 578.9,
    y1: 310.47,
    x2: 578.67,
    y2: 310.47
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 578.9,
    y1: 310.47,
    x2: 578.9,
    y2: 313.21
  })), _polyline26 || (_polyline26 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "578.67 313.58 578.9 313.58 578.9 313.21"
  })), _polyline27 || (_polyline27 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "578.67 313.58 577.39 313.58 577.39 313.81 580.79 313.81 580.79 313.58 579.28 313.58"
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 578.9,
    y1: 313.21,
    x2: 579.28,
    y2: 313.58
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 578.9,
    y1: 313.21,
    x2: 578.9,
    y2: 310.47
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 579.28,
    y1: 310.47,
    x2: 578.9,
    y2: 310.47
  })), _polyline28 || (_polyline28 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "579.28 310.47 580.79 310.47 580.79 310.1"
  })), _polyline29 || (_polyline29 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "462.12 492.93 458.72 492.93 458.72 493.3 460.23 493.3"
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 460.23,
    y1: 493.3,
    x2: 460.23,
    y2: 496.41
  })), _polyline30 || (_polyline30 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "460.23 496.41 458.72 496.41 458.72 496.63 462.12 496.63 462.12 496.41 460.61 496.41"
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 460.61,
    y1: 496.41,
    x2: 460.61,
    y2: 493.3
  })), _polyline31 || (_polyline31 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "460.61 493.3 462.12 493.3 462.12 492.93"
  })), _polyline32 || (_polyline32 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "462.12 310.1 458.72 310.1 458.72 310.47 460.23 310.47"
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 460.23,
    y1: 310.47,
    x2: 460.23,
    y2: 313.21
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 460.23,
    y1: 313.58,
    x2: 460.23,
    y2: 313.21
  })), _polyline33 || (_polyline33 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "460.23 313.58 458.72 313.58 458.72 313.81 462.12 313.81 462.12 313.58 460.61 313.58"
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 460.61,
    y1: 313.21,
    x2: 460.61,
    y2: 313.58
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 460.61,
    y1: 313.21,
    x2: 460.61,
    y2: 310.47
  })), _polyline34 || (_polyline34 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "460.61 310.47 462.12 310.47 462.12 310.1"
  })), _polyline35 || (_polyline35 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "343.68 492.93 340.05 492.93 340.05 493.3 341.79 493.3"
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 341.79,
    y1: 493.3,
    x2: 341.79,
    y2: 496.41
  })), _polyline36 || (_polyline36 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "341.79 496.41 340.05 496.41 340.05 496.63 343.68 496.63 343.68 496.41 341.94 496.41"
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 341.94,
    y1: 496.41,
    x2: 341.94,
    y2: 493.3
  })), _polyline37 || (_polyline37 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "341.94 493.3 343.68 493.3 343.68 492.93"
  })), _polyline38 || (_polyline38 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "343.68 310.1 340.05 310.1 340.05 310.47 341.79 310.47"
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 341.79,
    y1: 310.47,
    x2: 341.79,
    y2: 313.21
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 341.79,
    y1: 313.58,
    x2: 341.79,
    y2: 313.21
  })), _polyline39 || (_polyline39 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "341.79 313.58 340.05 313.58 340.05 313.81 343.68 313.81 343.68 313.58 341.94 313.58"
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 341.94,
    y1: 313.21,
    x2: 341.94,
    y2: 313.58
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 341.94,
    y1: 313.21,
    x2: 341.94,
    y2: 310.47
  })), _polyline40 || (_polyline40 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "341.94 310.47 343.68 310.47 343.68 310.1"
  })), _polyline41 || (_polyline41 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "225.01 310.1 221.38 310.1 221.38 310.47 223.12 310.47"
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.27,
    y1: 310.47,
    x2: 223.12,
    y2: 310.47
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.27,
    y1: 310.47,
    x2: 223.27,
    y2: 313.21
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.12,
    y1: 313.58,
    x2: 223.27,
    y2: 313.21
  })), _polyline42 || (_polyline42 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "223.12 313.58 221.38 313.58 221.38 313.81 225.01 313.81 225.01 313.58 223.27 313.58"
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.27,
    y1: 313.21,
    x2: 223.27,
    y2: 313.58
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.27,
    y1: 313.21,
    x2: 223.27,
    y2: 310.47
  })), _polyline43 || (_polyline43 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "223.27 310.47 225.01 310.47 225.01 310.1"
  })), _polyline44 || (_polyline44 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "225.01 492.93 221.38 492.93 221.38 493.3 223.12 493.3"
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.27,
    y1: 493.3,
    x2: 223.12,
    y2: 493.3
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.27,
    y1: 493.3,
    x2: 223.27,
    y2: 496.41
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.12,
    y1: 496.41,
    x2: 223.27,
    y2: 496.41
  })), _polyline45 || (_polyline45 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "223.12 496.41 221.38 496.41 221.38 496.63 225.01 496.63 225.01 496.41 223.27 496.41"
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.27,
    y1: 496.41,
    x2: 223.27,
    y2: 493.3
  })), _polyline46 || (_polyline46 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "223.27 493.3 225.01 493.3 225.01 492.93"
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 223.27,
    y1: 404.92,
    x2: 223.65,
    y2: 404.92
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 223.27,
    y1: 401.73,
    x2: 223.65,
    y2: 401.73
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 341.94,
    y1: 404.92,
    x2: 342.32,
    y2: 404.92
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 341.94,
    y1: 401.73,
    x2: 342.32,
    y2: 401.73
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 341.79,
    y1: 401.73,
    x2: 341.94,
    y2: 401.73
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 341.79,
    y1: 404.92,
    x2: 341.94,
    y2: 404.92
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 460.61,
    y1: 404.92,
    x2: 460.76,
    y2: 404.92
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 460.61,
    y1: 401.73,
    x2: 460.76,
    y2: 401.73
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 460.23,
    y1: 401.73,
    x2: 460.61,
    y2: 401.73
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 460.23,
    y1: 404.92,
    x2: 460.61,
    y2: 404.92
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 934.67,
    y1: 404.92,
    x2: 935.05,
    y2: 404.92
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 934.67,
    y1: 401.73,
    x2: 935.05,
    y2: 401.73
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 934.45,
    y1: 401.73,
    x2: 934.67,
    y2: 401.73
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 934.45,
    y1: 404.92,
    x2: 934.67,
    y2: 404.92
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 223.27,
    y1: 558.84,
    x2: 223.65,
    y2: 558.84
  })), _polyline47 || (_polyline47 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "221.38 251.23 225.01 251.23 223.27 251.23"
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.27,
    y1: 251.01,
    x2: 223.27,
    y2: 251.23
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.27,
    y1: 251.01,
    x2: 223.27,
    y2: 248.04
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.27,
    y1: 247.89,
    x2: 223.27,
    y2: 248.04
  })), _polyline48 || (_polyline48 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "223.27 247.89 225.01 247.89 221.38 247.89 223.12 247.89"
  })), _polyline49 || (_polyline49 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "223.27 248.04 223.12 248.04 223.12 247.89"
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.27,
    y1: 248.04,
    x2: 223.27,
    y2: 251.01
  })), _polyline50 || (_polyline50 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "223.12 251.23 223.12 251.01 223.27 251.01"
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.12,
    y1: 251.23,
    x2: 221.38,
    y2: 251.23
  })), _polyline51 || (_polyline51 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "221.38 405.29 225.01 405.29 225.01 404.92 223.27 404.92"
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.27,
    y1: 404.92,
    x2: 223.27,
    y2: 401.73
  })), _polyline52 || (_polyline52 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "223.27 401.73 225.01 401.73 225.01 401.59 221.38 401.59 221.38 401.73 223.12 401.73"
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.27,
    y1: 401.73,
    x2: 223.12,
    y2: 401.73
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.27,
    y1: 401.73,
    x2: 223.27,
    y2: 404.92
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.12,
    y1: 404.92,
    x2: 223.27,
    y2: 404.92
  })), _polyline53 || (_polyline53 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "223.12 404.92 221.38 404.92 221.38 405.29"
  })), _polyline54 || (_polyline54 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "340.05 405.29 343.68 405.29 343.68 404.92 341.94 404.92"
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 341.94,
    y1: 404.92,
    x2: 341.94,
    y2: 401.73
  })), _polyline55 || (_polyline55 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "341.94 401.73 343.68 401.73 343.68 401.59 340.05 401.59 340.05 401.73 341.79 401.73"
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 341.79,
    y1: 401.73,
    x2: 341.79,
    y2: 404.92
  })), _polyline56 || (_polyline56 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "341.79 404.92 340.05 404.92 340.05 405.29"
  })), _polyline57 || (_polyline57 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "458.72 405.29 462.12 405.29 462.12 404.92 460.61 404.92"
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 460.61,
    y1: 404.92,
    x2: 460.61,
    y2: 401.73
  })), _polyline58 || (_polyline58 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "460.61 401.73 462.12 401.73 462.12 401.59 458.72 401.59 458.72 401.73 460.23 401.73"
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 460.23,
    y1: 401.73,
    x2: 460.23,
    y2: 404.92
  })), _polyline59 || (_polyline59 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "460.23 404.92 458.72 404.92 458.72 405.29"
  })), _polyline60 || (_polyline60 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "577.39 405.29 580.79 405.29 580.79 404.92 579.28 404.92"
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 578.9,
    y1: 404.92,
    x2: 579.28,
    y2: 404.92
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 578.9,
    y1: 404.92,
    x2: 578.9,
    y2: 401.73
  })), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 579.28,
    y1: 401.73,
    x2: 578.9,
    y2: 401.73
  })), _polyline61 || (_polyline61 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "579.28 401.73 580.79 401.73 580.79 401.59 577.39 401.59 577.39 401.73 578.67 401.73"
  })), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 578.9,
    y1: 401.73,
    x2: 578.67,
    y2: 401.73
  })), _line113 || (_line113 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 578.9,
    y1: 401.73,
    x2: 578.9,
    y2: 404.92
  })), _line114 || (_line114 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 578.67,
    y1: 404.92,
    x2: 578.9,
    y2: 404.92
  })), _polyline62 || (_polyline62 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "578.67 404.92 577.39 404.92 577.39 405.29"
  })), _polyline63 || (_polyline63 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "695.68 405.29 699.46 405.29 699.46 404.92 697.72 404.92"
  })), _line115 || (_line115 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.57,
    y1: 404.92,
    x2: 697.72,
    y2: 404.92
  })), _line116 || (_line116 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.57,
    y1: 404.92,
    x2: 697.57,
    y2: 401.73
  })), _line117 || (_line117 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.72,
    y1: 401.73,
    x2: 697.57,
    y2: 401.73
  })), _polyline64 || (_polyline64 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "697.72 401.73 699.46 401.73 699.46 401.59 695.68 401.59 695.68 401.73 697.34 401.73"
  })), _line118 || (_line118 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.57,
    y1: 401.73,
    x2: 697.34,
    y2: 401.73
  })), _line119 || (_line119 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.57,
    y1: 401.73,
    x2: 697.57,
    y2: 404.92
  })), _line120 || (_line120 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.34,
    y1: 404.92,
    x2: 697.57,
    y2: 404.92
  })), _polyline65 || (_polyline65 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "697.34 404.92 695.68 404.92 695.68 405.29"
  })), _polyline66 || (_polyline66 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "814.27 405.29 817.67 405.29 817.67 404.92 816.39 404.92"
  })), _line121 || (_line121 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 816.16,
    y1: 404.92,
    x2: 816.39,
    y2: 404.92
  })), _line122 || (_line122 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 816.16,
    y1: 404.92,
    x2: 816.16,
    y2: 401.73
  })), _line123 || (_line123 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 816.39,
    y1: 401.73,
    x2: 816.16,
    y2: 401.73
  })), _polyline67 || (_polyline67 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "816.39 401.73 817.67 401.73 817.67 401.59 814.27 401.59 814.27 401.73 815.78 401.73"
  })), _line124 || (_line124 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 816.16,
    y1: 401.73,
    x2: 815.78,
    y2: 401.73
  })), _line125 || (_line125 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 816.16,
    y1: 401.73,
    x2: 816.16,
    y2: 404.92
  })), _line126 || (_line126 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 815.78,
    y1: 404.92,
    x2: 816.16,
    y2: 404.92
  })), _polyline68 || (_polyline68 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "815.78 404.92 814.27 404.92 814.27 405.29"
  })), _polyline69 || (_polyline69 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "932.78 405.29 936.34 405.29 936.34 404.92 934.67 404.92"
  })), _line127 || (_line127 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 934.67,
    y1: 404.92,
    x2: 934.67,
    y2: 401.73
  })), _polyline70 || (_polyline70 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "934.67 401.73 936.34 401.73 936.34 401.59 932.78 401.59 932.78 401.73 934.45 401.73"
  })), _line128 || (_line128 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 934.45,
    y1: 401.73,
    x2: 934.45,
    y2: 404.92
  })), _polyline71 || (_polyline71 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "934.45 404.92 932.78 404.92 932.78 405.29"
  })), _polyline72 || (_polyline72 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "221.38 558.99 225.01 558.99 225.01 558.84 223.27 558.84"
  })), _line129 || (_line129 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.27,
    y1: 558.84,
    x2: 223.27,
    y2: 555.87
  })), _line130 || (_line130 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.27,
    y1: 555.5,
    x2: 223.27,
    y2: 555.87
  })), _polyline73 || (_polyline73 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "223.27 555.5 225.01 555.5 221.38 555.5 223.12 555.5"
  })), _line131 || (_line131 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.27,
    y1: 555.87,
    x2: 223.12,
    y2: 555.5
  })), _line132 || (_line132 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.27,
    y1: 555.87,
    x2: 223.27,
    y2: 558.84
  })), _line133 || (_line133 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223.12,
    y1: 558.84,
    x2: 223.27,
    y2: 558.84
  })), _polyline74 || (_polyline74 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "223.12 558.84 221.38 558.84 221.38 558.99"
  })), _line134 || (_line134 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 992.08,
    y1: 565.88,
    x2: 223.27,
    y2: 565.88
  })), _line135 || (_line135 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 992.08,
    y1: 565.88,
    x2: 1006.07,
    y2: 552.16
  })), _line136 || (_line136 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1006.07,
    y1: 254.34,
    x2: 1006.07,
    y2: 552.16
  })), _line137 || (_line137 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 992.08,
    y1: 241,
    x2: 1006.07,
    y2: 254.34
  })), _line138 || (_line138 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 213.29,
    y1: 232.99,
    x2: 213.29,
    y2: 565.88
  })), _line139 || (_line139 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 211.78,
    y1: 232.99,
    x2: 211.78,
    y2: 565.88
  })), _line140 || (_line140 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 965.23,
    y1: 566.99,
    x2: 967.12,
    y2: 566.99
  })), _line141 || (_line141 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 965.23,
    y1: 239.89,
    x2: 967.12,
    y2: 239.89
  })), _line142 || (_line142 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 965.23,
    y1: 566.99,
    x2: 965.23,
    y2: 390.98
  })), _line143 || (_line143 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 965.23,
    y1: 365.93,
    x2: 965.23,
    y2: 239.89
  })), _line144 || (_line144 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 967.12,
    y1: 566.99,
    x2: 967.12,
    y2: 390.98
  })), _line145 || (_line145 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 967.12,
    y1: 365.93,
    x2: 967.12,
    y2: 239.89
  })), _line146 || (_line146 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 965.23,
    y1: 365.93,
    x2: 967.12,
    y2: 365.93
  })), _line147 || (_line147 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 965.23,
    y1: 390.98,
    x2: 967.12,
    y2: 390.98
  })), _line148 || (_line148 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 983.38,
    y1: 405.89,
    x2: 983.38,
    y2: 474.17
  })), _line149 || (_line149 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 967.12,
    y1: 405.89,
    x2: 982.63,
    y2: 405.89
  })), _line150 || (_line150 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 211.78,
    y1: 232.99,
    x2: 213.29,
    y2: 232.99
  })), _line151 || (_line151 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 967.73,
    y1: 565.88,
    x2: 967.73,
    y2: 478.99
  })), _line152 || (_line152 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 968.48,
    y1: 530.59,
    x2: 968.48,
    y2: 478.62
  })), _line153 || (_line153 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 983.38,
    y1: 530.59,
    x2: 983.38,
    y2: 474.17
  })), _line154 || (_line154 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 982.63,
    y1: 530.59,
    x2: 982.63,
    y2: 474.39
  })), _line155 || (_line155 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 976.05,
    y1: 476.62,
    x2: 982.63,
    y2: 476.62
  })), _line156 || (_line156 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 968.48,
    y1: 480.32,
    x2: 982.63,
    y2: 480.32
  })), _line157 || (_line157 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 968.48,
    y1: 484.03,
    x2: 982.63,
    y2: 484.03
  })), _line158 || (_line158 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 968.48,
    y1: 487.89,
    x2: 982.63,
    y2: 487.89
  })), _line159 || (_line159 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 968.48,
    y1: 491.59,
    x2: 982.63,
    y2: 491.59
  })), _line160 || (_line160 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 968.48,
    y1: 495.67,
    x2: 982.63,
    y2: 495.67
  })), _line161 || (_line161 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 968.48,
    y1: 499.45,
    x2: 982.63,
    y2: 499.45
  })), _line162 || (_line162 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 968.48,
    y1: 503.16,
    x2: 982.63,
    y2: 503.16
  })), _line163 || (_line163 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 968.48,
    y1: 507.01,
    x2: 982.63,
    y2: 507.01
  })), _line164 || (_line164 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 968.48,
    y1: 510.72,
    x2: 982.63,
    y2: 510.72
  })), _line165 || (_line165 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 968.48,
    y1: 514.43,
    x2: 982.63,
    y2: 514.43
  })), _line166 || (_line166 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 968.48,
    y1: 518.5,
    x2: 982.63,
    y2: 518.5
  })), _line167 || (_line167 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 968.48,
    y1: 522.29,
    x2: 982.63,
    y2: 522.29
  })), _line168 || (_line168 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 982.63,
    y1: 530.59,
    x2: 983.38,
    y2: 530.59
  })), _line169 || (_line169 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 968.48,
    y1: 530.59,
    x2: 967.12,
    y2: 530.59
  })), _line170 || (_line170 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 967.73,
    y1: 529.85,
    x2: 967.12,
    y2: 529.85
  })), _line171 || (_line171 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 963.57,
    y1: 479.95,
    x2: 987.77,
    y2: 473.06
  })), _line172 || (_line172 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 211.78,
    y1: 565.88,
    x2: 965.23,
    y2: 565.88
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 211.02,
    y: 220.56,
    width: 0.76,
    height: 12.44
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 211.02,
    y: 233.01,
    width: 0.76,
    height: 12.44
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 967.12,
    y: 365.91,
    width: 0.57,
    height: 12.62
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 967.12,
    y: 353.49,
    width: 0.57,
    height: 12.44
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 967.12,
    y: 378.55,
    width: 0.57,
    height: 12.44
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 967.12,
    y: 391,
    width: 0.57,
    height: 12.44
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 967.73,
    y: 353.5,
    width: 1.32,
    height: 49.94
  })), _line173 || (_line173 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 211.25,
    y1: 609.33,
    x2: 211.25,
    y2: 588.72
  })), _line174 || (_line174 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 211.78,
    y1: 588.34,
    x2: 211.78,
    y2: 600.95
  })), _line175 || (_line175 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 213.29,
    y1: 586.27,
    x2: 213.29,
    y2: 601.17
  })), _line176 || (_line176 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 955.78,
    y1: 481.58,
    x2: 956,
    y2: 481.58
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "964.7 252.86 962.81 246.04 957.67 241.22 950.71 239.37 943.9 241.22 938.84 246.04 936.94 252.86 938.84 259.76 943.9 264.8 950.71 266.65 957.67 264.8 962.81 259.76 964.7 252.86"
  })), _line177 || (_line177 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 940.88,
    y1: 243.22,
    x2: 960.69,
    y2: 262.72
  })), _line178 || (_line178 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 940.88,
    y1: 262.72,
    x2: 960.69,
    y2: 243.22
  })), _line179 || (_line179 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 339.9,
    y1: 309.88,
    x2: 343.83,
    y2: 309.88
  })), _line180 || (_line180 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 341.94,
    y1: 309.88,
    x2: 341.94,
    y2: 314.18
  })), _line181 || (_line181 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 339.9,
    y1: 314.18,
    x2: 343.83,
    y2: 314.18
  })), _line182 || (_line182 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 458.34,
    y1: 309.88,
    x2: 462.5,
    y2: 309.88
  })), _line183 || (_line183 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 460.23,
    y1: 309.88,
    x2: 460.23,
    y2: 314.18
  })), _line184 || (_line184 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 458.34,
    y1: 314.18,
    x2: 462.5,
    y2: 314.18
  })), _line185 || (_line185 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 274.1,
    y1: 273.84,
    x2: 274.1,
    y2: 266.43
  })), _line186 || (_line186 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 278.49,
    y1: 307.65,
    x2: 278.49,
    y2: 322.85
  })), _line187 || (_line187 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 276.6,
    y1: 307.65,
    x2: 276.6,
    y2: 327.3
  })), _line188 || (_line188 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 283.02,
    y1: 307.65,
    x2: 283.02,
    y2: 293.34
  })), _line189 || (_line189 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 283.02,
    y1: 293.34,
    x2: 275.99,
    y2: 287.04
  })), _line190 || (_line190 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 274.1,
    y1: 327.3,
    x2: 274.1,
    y2: 307.65
  })), _line191 || (_line191 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 275.99,
    y1: 287.04,
    x2: 275.99,
    y2: 273.84
  })), _line192 || (_line192 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 267.14,
    y1: 271.62,
    x2: 267.14,
    y2: 266.43
  })), _line193 || (_line193 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 272.59,
    y1: 265.54,
    x2: 272.59,
    y2: 266.43
  })), _line194 || (_line194 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 278.49,
    y1: 265.54,
    x2: 272.59,
    y2: 265.54
  })), _line195 || (_line195 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 267.14,
    y1: 266.43,
    x2: 274.1,
    y2: 266.43
  })), _line196 || (_line196 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 281.51,
    y1: 328.04,
    x2: 280.75,
    y2: 328.04
  })), _line197 || (_line197 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 277.35,
    y1: 322.85,
    x2: 281.51,
    y2: 322.85
  })), _line198 || (_line198 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 281.51,
    y1: 322.85,
    x2: 281.51,
    y2: 328.04
  })), _line199 || (_line199 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 280.75,
    y1: 336.79,
    x2: 280.75,
    y2: 327.3
  })), _line200 || (_line200 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 270.17,
    y1: 336.79,
    x2: 280.75,
    y2: 336.79
  })), _line201 || (_line201 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 280.75,
    y1: 327.3,
    x2: 270.17,
    y2: 327.3
  })), _line202 || (_line202 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 267.9,
    y1: 326.19,
    x2: 236.51,
    y2: 326.19
  })), _line203 || (_line203 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 267.9,
    y1: 326.19,
    x2: 267.9,
    y2: 358.88
  })), _line204 || (_line204 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 280.15,
    y1: 343.83,
    x2: 270.7,
    y2: 343.83
  })), _line205 || (_line205 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 270.17,
    y1: 327.3,
    x2: 270.17,
    y2: 336.79
  })), _line206 || (_line206 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 274.1,
    y1: 271.62,
    x2: 267.14,
    y2: 271.62
  })), _line207 || (_line207 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 283.02,
    y1: 272.73,
    x2: 283.02,
    y2: 265.54
  })), _line208 || (_line208 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 283.02,
    y1: 265.54,
    x2: 278.49,
    y2: 265.54
  })), _line209 || (_line209 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 274.1,
    y1: 272.73,
    x2: 283.02,
    y2: 272.73
  })), _line210 || (_line210 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 270.7,
    y1: 337.38,
    x2: 270.7,
    y2: 343.83
  })), _line211 || (_line211 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 280.15,
    y1: 337.38,
    x2: 280.15,
    y2: 343.83
  })), _line212 || (_line212 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 280.15,
    y1: 337.38,
    x2: 270.7,
    y2: 337.38
  })), _line213 || (_line213 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 275.99,
    y1: 273.84,
    x2: 233.11,
    y2: 273.84
  })), _line214 || (_line214 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 283.02,
    y1: 307.65,
    x2: 233.11,
    y2: 307.65
  })), _line215 || (_line215 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 233.11,
    y1: 307.65,
    x2: 233.11,
    y2: 273.84
  })), _line216 || (_line216 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 236.51,
    y1: 358.88,
    x2: 236.51,
    y2: 326.19
  })), _line217 || (_line217 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 267.9,
    y1: 358.88,
    x2: 236.51,
    y2: 358.88
  })), _line218 || (_line218 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 272.59,
    y1: 327.3,
    x2: 272.59,
    y2: 307.65
  })), _line219 || (_line219 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 275.99,
    y1: 479.21,
    x2: 244.3,
    y2: 479.21
  })), _line220 || (_line220 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 248.46,
    y1: 540.45,
    x2: 235.22,
    y2: 540.45
  })), _line221 || (_line221 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 229.55,
    y1: 514.43,
    x2: 235.22,
    y2: 519.99
  })), _line222 || (_line222 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 235.22,
    y1: 533.04,
    x2: 235.22,
    y2: 519.99
  })), _line223 || (_line223 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 279.62,
    y1: 533.04,
    x2: 235.22,
    y2: 533.04
  })), _line224 || (_line224 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 229.55,
    y1: 498.86,
    x2: 279.62,
    y2: 498.86
  })), _line225 || (_line225 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 229.55,
    y1: 514.43,
    x2: 229.55,
    y2: 498.86
  })), _line226 || (_line226 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 279.62,
    y1: 498.86,
    x2: 279.62,
    y2: 533.04
  })), _line227 || (_line227 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 242.03,
    y1: 481.43,
    x2: 230.84,
    y2: 481.43
  })), _polyline75 || (_polyline75 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "230.69 481.06 230.69 481.43 230.84 481.43"
  })), _line228 || (_line228 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 230.69,
    y1: 472.32,
    x2: 228.57,
    y2: 472.32
  })), _polyline76 || (_polyline76 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "242.03 481.43 242.18 481.43 242.18 481.06"
  })), _polyline77 || (_polyline77 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "230.84 469.87 230.69 470.24 230.69 470.46"
  })), _line229 || (_line229 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 230.84,
    y1: 469.87,
    x2: 242.03,
    y2: 469.87
  })), _line230 || (_line230 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 242.18,
    y1: 462.31,
    x2: 228.57,
    y2: 462.31
  })), _line231 || (_line231 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 242.18,
    y1: 470.24,
    x2: 242.03,
    y2: 469.87
  })), _line232 || (_line232 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 242.18,
    y1: 462.31,
    x2: 242.18,
    y2: 481.06
  })), _line233 || (_line233 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 244.3,
    y1: 479.21,
    x2: 244.3,
    y2: 455.41
  })), _line234 || (_line234 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 228.57,
    y1: 472.32,
    x2: 228.57,
    y2: 462.31
  })), _line235 || (_line235 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 230.69,
    y1: 481.06,
    x2: 230.69,
    y2: 470.24
  })), _line236 || (_line236 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 275.99,
    y1: 479.21,
    x2: 275.99,
    y2: 455.41
  })), _line237 || (_line237 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 281.13,
    y1: 475.28,
    x2: 262.83,
    y2: 475.28
  })), _line238 || (_line238 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 281.13,
    y1: 457.27,
    x2: 262.83,
    y2: 457.27
  })), _line239 || (_line239 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 244.3,
    y1: 455.41,
    x2: 275.99,
    y2: 455.41
  })), _line240 || (_line240 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 262.83,
    y1: 475.28,
    x2: 262.83,
    y2: 457.27
  })), _line241 || (_line241 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 281.13,
    y1: 475.28,
    x2: 281.13,
    y2: 457.27
  })), _line242 || (_line242 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 234.62,
    y1: 481.43,
    x2: 234.62,
    y2: 498.86
  })), _line243 || (_line243 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 237.49,
    y1: 481.43,
    x2: 237.49,
    y2: 498.86
  })), _line244 || (_line244 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 235.22,
    y1: 540.45,
    x2: 235.22,
    y2: 533.04
  })), _line245 || (_line245 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 248.46,
    y1: 533.04,
    x2: 248.46,
    y2: 540.45
  })), _line246 || (_line246 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 333.24,
    y1: 273.84,
    x2: 333.24,
    y2: 266.43
  })), _line247 || (_line247 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 337.63,
    y1: 307.65,
    x2: 337.63,
    y2: 322.85
  })), _line248 || (_line248 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 335.74,
    y1: 307.65,
    x2: 335.74,
    y2: 327.3
  })), _line249 || (_line249 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 342.32,
    y1: 307.65,
    x2: 342.32,
    y2: 293.34
  })), _line250 || (_line250 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 342.32,
    y1: 293.34,
    x2: 335.13,
    y2: 287.04
  })), _line251 || (_line251 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 333.24,
    y1: 327.3,
    x2: 333.24,
    y2: 307.65
  })), _line252 || (_line252 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 335.13,
    y1: 287.04,
    x2: 335.13,
    y2: 273.84
  })), _line253 || (_line253 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 326.29,
    y1: 271.62,
    x2: 326.29,
    y2: 266.43
  })), _line254 || (_line254 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 331.73,
    y1: 265.54,
    x2: 331.73,
    y2: 266.43
  })), _line255 || (_line255 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 337.63,
    y1: 265.54,
    x2: 331.73,
    y2: 265.54
  })), _line256 || (_line256 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 326.29,
    y1: 266.43,
    x2: 333.24,
    y2: 266.43
  })), _line257 || (_line257 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 336.65,
    y1: 322.85,
    x2: 336.65,
    y2: 327.3
  })), _line258 || (_line258 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 340.66,
    y1: 328.04,
    x2: 339.9,
    y2: 328.04
  })), _line259 || (_line259 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 336.65,
    y1: 322.85,
    x2: 340.66,
    y2: 322.85
  })), _line260 || (_line260 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 340.66,
    y1: 322.85,
    x2: 340.66,
    y2: 328.04
  })), _line261 || (_line261 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 339.9,
    y1: 336.79,
    x2: 339.9,
    y2: 327.3
  })), _line262 || (_line262 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 329.31,
    y1: 336.79,
    x2: 339.9,
    y2: 336.79
  })), _line263 || (_line263 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 339.9,
    y1: 327.3,
    x2: 329.31,
    y2: 327.3
  })), _line264 || (_line264 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 327.04,
    y1: 326.19,
    x2: 295.88,
    y2: 326.19
  })), _line265 || (_line265 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 327.04,
    y1: 326.19,
    x2: 327.04,
    y2: 358.88
  })), _line266 || (_line266 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 339.29,
    y1: 343.83,
    x2: 329.84,
    y2: 343.83
  })), _line267 || (_line267 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 329.31,
    y1: 327.3,
    x2: 329.31,
    y2: 336.79
  })), _line268 || (_line268 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 333.24,
    y1: 271.62,
    x2: 326.29,
    y2: 271.62
  })), _line269 || (_line269 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 342.32,
    y1: 272.73,
    x2: 342.32,
    y2: 265.54
  })), _line270 || (_line270 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 342.32,
    y1: 265.54,
    x2: 337.63,
    y2: 265.54
  })), _line271 || (_line271 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 333.24,
    y1: 272.73,
    x2: 342.32,
    y2: 272.73
  })), _line272 || (_line272 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 329.84,
    y1: 337.38,
    x2: 329.84,
    y2: 343.83
  })), _line273 || (_line273 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 339.29,
    y1: 337.38,
    x2: 339.29,
    y2: 343.83
  })), _line274 || (_line274 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 339.29,
    y1: 337.38,
    x2: 329.84,
    y2: 337.38
  })), _line275 || (_line275 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 335.13,
    y1: 273.84,
    x2: 292.25,
    y2: 273.84
  })), _line276 || (_line276 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 342.32,
    y1: 307.65,
    x2: 292.25,
    y2: 307.65
  })), _line277 || (_line277 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 292.25,
    y1: 307.65,
    x2: 292.25,
    y2: 273.84
  })), _line278 || (_line278 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 295.88,
    y1: 358.88,
    x2: 295.88,
    y2: 326.19
  })), _line279 || (_line279 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 327.04,
    y1: 358.88,
    x2: 295.88,
    y2: 358.88
  })), _line280 || (_line280 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 331.73,
    y1: 327.3,
    x2: 331.73,
    y2: 307.65
  })), _line281 || (_line281 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 392.77,
    y1: 273.84,
    x2: 392.77,
    y2: 266.43
  })), _line282 || (_line282 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 396.78,
    y1: 307.65,
    x2: 396.78,
    y2: 322.85
  })), _line283 || (_line283 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 395.26,
    y1: 307.65,
    x2: 395.26,
    y2: 327.3
  })), _line284 || (_line284 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 401.69,
    y1: 307.65,
    x2: 401.69,
    y2: 293.34
  })), _line285 || (_line285 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 401.69,
    y1: 293.34,
    x2: 394.66,
    y2: 287.04
  })), _line286 || (_line286 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 392.77,
    y1: 327.3,
    x2: 392.77,
    y2: 307.65
  })), _line287 || (_line287 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 394.66,
    y1: 287.04,
    x2: 394.66,
    y2: 273.84
  })), _line288 || (_line288 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 385.81,
    y1: 271.62,
    x2: 385.81,
    y2: 266.43
  })), _line289 || (_line289 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 390.88,
    y1: 265.54,
    x2: 390.88,
    y2: 266.43
  })), _line290 || (_line290 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 396.78,
    y1: 265.54,
    x2: 390.88,
    y2: 265.54
  })), _line291 || (_line291 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 385.81,
    y1: 266.43,
    x2: 392.77,
    y2: 266.43
  })), _line292 || (_line292 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 395.79,
    y1: 322.85,
    x2: 395.79,
    y2: 327.3
  })), _line293 || (_line293 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 400.18,
    y1: 328.04,
    x2: 399.2,
    y2: 328.04
  })), _line294 || (_line294 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 395.79,
    y1: 322.85,
    x2: 400.18,
    y2: 322.85
  })), _line295 || (_line295 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 400.18,
    y1: 322.85,
    x2: 400.18,
    y2: 328.04
  })), _line296 || (_line296 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 399.2,
    y1: 336.79,
    x2: 399.2,
    y2: 327.3
  })), _line297 || (_line297 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 388.83,
    y1: 336.79,
    x2: 399.2,
    y2: 336.79
  })), _line298 || (_line298 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 399.2,
    y1: 327.3,
    x2: 388.83,
    y2: 327.3
  })), _line299 || (_line299 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 386.57,
    y1: 326.19,
    x2: 355.03,
    y2: 326.19
  })), _line300 || (_line300 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 386.57,
    y1: 326.19,
    x2: 386.57,
    y2: 358.88
  })), _line301 || (_line301 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 398.67,
    y1: 343.83,
    x2: 389.21,
    y2: 343.83
  })), _line302 || (_line302 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 398.67,
    y1: 337.38,
    x2: 398.67,
    y2: 343.83
  })), _line303 || (_line303 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 388.83,
    y1: 327.3,
    x2: 388.83,
    y2: 336.79
  })), _line304 || (_line304 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 392.77,
    y1: 271.62,
    x2: 385.81,
    y2: 271.62
  })), _line305 || (_line305 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 401.69,
    y1: 272.73,
    x2: 401.69,
    y2: 265.54
  })), _line306 || (_line306 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 401.69,
    y1: 265.54,
    x2: 396.78,
    y2: 265.54
  })), _line307 || (_line307 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 392.77,
    y1: 272.73,
    x2: 401.69,
    y2: 272.73
  })), _line308 || (_line308 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 389.21,
    y1: 337.38,
    x2: 389.21,
    y2: 343.83
  })), _line309 || (_line309 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 398.67,
    y1: 337.38,
    x2: 389.21,
    y2: 337.38
  })), _line310 || (_line310 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 394.66,
    y1: 273.84,
    x2: 351.4,
    y2: 273.84
  })), _line311 || (_line311 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 401.69,
    y1: 307.65,
    x2: 351.4,
    y2: 307.65
  })), _line312 || (_line312 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 351.4,
    y1: 307.65,
    x2: 351.4,
    y2: 273.84
  })), _line313 || (_line313 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 355.03,
    y1: 358.88,
    x2: 355.03,
    y2: 326.19
  })), _line314 || (_line314 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 386.57,
    y1: 358.88,
    x2: 355.03,
    y2: 358.88
  })), _line315 || (_line315 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 390.88,
    y1: 327.3,
    x2: 390.88,
    y2: 307.65
  })), _line316 || (_line316 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 456.07,
    y1: 307.65,
    x2: 456.07,
    y2: 322.85
  })), _line317 || (_line317 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 454.41,
    y1: 307.65,
    x2: 454.41,
    y2: 327.3
  })), _line318 || (_line318 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 460.61,
    y1: 307.65,
    x2: 460.61,
    y2: 293.34
  })), _line319 || (_line319 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 460.61,
    y1: 293.34,
    x2: 453.65,
    y2: 287.04
  })), _line320 || (_line320 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 451.76,
    y1: 327.3,
    x2: 451.76,
    y2: 307.65
  })), _line321 || (_line321 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 453.65,
    y1: 287.04,
    x2: 453.65,
    y2: 273.84
  })), _line322 || (_line322 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 444.95,
    y1: 271.62,
    x2: 444.95,
    y2: 266.06
  })), _line323 || (_line323 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 450.02,
    y1: 265.54,
    x2: 450.02,
    y2: 266.06
  })), _line324 || (_line324 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 456.07,
    y1: 265.54,
    x2: 450.02,
    y2: 265.54
  })), _line325 || (_line325 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 444.95,
    y1: 266.06,
    x2: 451.76,
    y2: 266.06
  })), _line326 || (_line326 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 454.94,
    y1: 322.85,
    x2: 454.94,
    y2: 327.3
  })), _line327 || (_line327 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 458.95,
    y1: 328.04,
    x2: 458.19,
    y2: 328.04
  })), _line328 || (_line328 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 454.94,
    y1: 322.85,
    x2: 458.95,
    y2: 322.85
  })), _line329 || (_line329 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 458.95,
    y1: 322.85,
    x2: 458.95,
    y2: 328.04
  })), _line330 || (_line330 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 458.19,
    y1: 336.79,
    x2: 458.19,
    y2: 327.3
  })), _line331 || (_line331 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 447.98,
    y1: 336.79,
    x2: 458.19,
    y2: 336.79
  })), _line332 || (_line332 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 458.19,
    y1: 327.3,
    x2: 447.98,
    y2: 327.3
  })), _line333 || (_line333 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 445.48,
    y1: 326.19,
    x2: 414.1,
    y2: 326.19
  })), _line334 || (_line334 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 445.48,
    y1: 326.19,
    x2: 445.48,
    y2: 358.88
  })), _line335 || (_line335 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 457.58,
    y1: 343.83,
    x2: 448.51,
    y2: 343.83
  })), _line336 || (_line336 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 457.58,
    y1: 337.38,
    x2: 457.58,
    y2: 343.83
  })), _line337 || (_line337 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 447.98,
    y1: 327.3,
    x2: 447.98,
    y2: 336.79
  })), _line338 || (_line338 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 451.76,
    y1: 271.62,
    x2: 444.95,
    y2: 271.62
  })), _line339 || (_line339 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 460.61,
    y1: 272.73,
    x2: 460.61,
    y2: 265.54
  })), _line340 || (_line340 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 460.61,
    y1: 265.54,
    x2: 456.07,
    y2: 265.54
  })), _line341 || (_line341 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 451.76,
    y1: 272.73,
    x2: 460.61,
    y2: 272.73
  })), _line342 || (_line342 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 448.51,
    y1: 337.38,
    x2: 448.51,
    y2: 343.83
  })), _line343 || (_line343 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 457.58,
    y1: 337.38,
    x2: 448.51,
    y2: 337.38
  })), _line344 || (_line344 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 453.65,
    y1: 273.84,
    x2: 410.54,
    y2: 273.84
  })), _line345 || (_line345 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 460.61,
    y1: 307.65,
    x2: 410.54,
    y2: 307.65
  })), _line346 || (_line346 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 410.54,
    y1: 307.65,
    x2: 410.54,
    y2: 273.84
  })), _line347 || (_line347 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 414.1,
    y1: 358.88,
    x2: 414.1,
    y2: 326.19
  })), _line348 || (_line348 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 445.48,
    y1: 358.88,
    x2: 414.1,
    y2: 358.88
  })), _line349 || (_line349 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 450.02,
    y1: 327.3,
    x2: 450.02,
    y2: 307.65
  })), _line350 || (_line350 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 277.35,
    y1: 322.85,
    x2: 277.35,
    y2: 327.3
  })), _line351 || (_line351 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 335.13,
    y1: 479.21,
    x2: 303.44,
    y2: 479.21
  })), _line352 || (_line352 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 307.76,
    y1: 540.45,
    x2: 294.14,
    y2: 540.45
  })), _line353 || (_line353 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 288.7,
    y1: 514.43,
    x2: 294.14,
    y2: 519.99
  })), _line354 || (_line354 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 294.14,
    y1: 533.04,
    x2: 294.14,
    y2: 519.99
  })), _line355 || (_line355 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 338.77,
    y1: 533.04,
    x2: 294.14,
    y2: 533.04
  })), _line356 || (_line356 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 288.7,
    y1: 498.86,
    x2: 338.77,
    y2: 498.86
  })), _line357 || (_line357 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 288.7,
    y1: 514.43,
    x2: 288.7,
    y2: 498.86
  })), _line358 || (_line358 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 338.77,
    y1: 498.86,
    x2: 338.77,
    y2: 533.04
  })), _line359 || (_line359 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 301.18,
    y1: 481.43,
    x2: 290.21,
    y2: 481.43
  })), _polyline78 || (_polyline78 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "289.83 481.06 289.83 481.43 290.21 481.43"
  })), _line360 || (_line360 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 289.83,
    y1: 472.32,
    x2: 287.33,
    y2: 472.32
  })), _polyline79 || (_polyline79 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "301.18 481.43 301.55 481.43 301.55 481.06"
  })), _polyline80 || (_polyline80 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "290.21 469.87 289.83 470.24 289.83 470.46"
  })), _line361 || (_line361 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 290.21,
    y1: 469.87,
    x2: 301.18,
    y2: 469.87
  })), _line362 || (_line362 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 301.55,
    y1: 462.31,
    x2: 287.33,
    y2: 462.31
  })), _line363 || (_line363 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 301.55,
    y1: 470.24,
    x2: 301.18,
    y2: 469.87
  })), _line364 || (_line364 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 301.55,
    y1: 462.31,
    x2: 301.55,
    y2: 481.06
  })), _line365 || (_line365 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 303.44,
    y1: 479.21,
    x2: 303.44,
    y2: 455.41
  })), _line366 || (_line366 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 287.33,
    y1: 472.32,
    x2: 287.33,
    y2: 462.31
  })), _line367 || (_line367 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 289.83,
    y1: 481.06,
    x2: 289.83,
    y2: 470.24
  })), _line368 || (_line368 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 335.13,
    y1: 479.21,
    x2: 335.13,
    y2: 455.41
  })), _line369 || (_line369 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 340.05,
    y1: 475.28,
    x2: 321.75,
    y2: 475.28
  })), _line370 || (_line370 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 340.05,
    y1: 457.27,
    x2: 321.75,
    y2: 457.27
  })), _line371 || (_line371 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 303.44,
    y1: 455.41,
    x2: 335.13,
    y2: 455.41
  })), _line372 || (_line372 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 321.75,
    y1: 475.28,
    x2: 321.75,
    y2: 457.27
  })), _line373 || (_line373 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 340.05,
    y1: 475.28,
    x2: 340.05,
    y2: 457.27
  })), _line374 || (_line374 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 293.99,
    y1: 481.43,
    x2: 293.99,
    y2: 498.86
  })), _line375 || (_line375 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 296.64,
    y1: 481.43,
    x2: 296.64,
    y2: 498.86
  })), _line376 || (_line376 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 294.14,
    y1: 540.45,
    x2: 294.14,
    y2: 533.04
  })), _line377 || (_line377 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 307.76,
    y1: 533.04,
    x2: 307.76,
    y2: 540.45
  })), _line378 || (_line378 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 394.66,
    y1: 479.21,
    x2: 362.74,
    y2: 479.21
  })), _line379 || (_line379 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 367.05,
    y1: 540.45,
    x2: 353.89,
    y2: 540.45
  })), _line380 || (_line380 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 348.22,
    y1: 514.8,
    x2: 353.66,
    y2: 519.99
  })), _line381 || (_line381 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 353.66,
    y1: 533.04,
    x2: 353.66,
    y2: 519.99
  })), _line382 || (_line382 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 398.29,
    y1: 533.04,
    x2: 353.66,
    y2: 533.04
  })), _line383 || (_line383 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 348.22,
    y1: 498.86,
    x2: 398.29,
    y2: 498.86
  })), _line384 || (_line384 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 348.22,
    y1: 514.8,
    x2: 348.22,
    y2: 498.86
  })), _line385 || (_line385 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 398.29,
    y1: 498.86,
    x2: 398.29,
    y2: 533.04
  })), _line386 || (_line386 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 360.7,
    y1: 481.58,
    x2: 349.51,
    y2: 481.58
  })), _polyline81 || (_polyline81 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "349.35 481.06 349.35 481.43 349.51 481.58"
  })), _line387 || (_line387 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 349.35,
    y1: 472.32,
    x2: 347.08,
    y2: 472.32
  })), _polyline82 || (_polyline82 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "360.7 481.58 360.85 481.43 360.85 481.06"
  })), _polyline83 || (_polyline83 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "349.51 470.24 349.35 470.24 349.35 470.46"
  })), _line388 || (_line388 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 349.51,
    y1: 470.24,
    x2: 360.7,
    y2: 470.24
  })), _line389 || (_line389 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 360.85,
    y1: 462.31,
    x2: 347.08,
    y2: 462.31
  })), _polyline84 || (_polyline84 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "360.85 470.46 360.85 470.24 360.7 470.24"
  })), _line390 || (_line390 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 360.85,
    y1: 462.31,
    x2: 360.85,
    y2: 481.06
  })), _line391 || (_line391 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 362.74,
    y1: 479.21,
    x2: 362.74,
    y2: 455.41
  })), _line392 || (_line392 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 347.08,
    y1: 472.32,
    x2: 347.08,
    y2: 462.31
  })), _line393 || (_line393 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 349.35,
    y1: 481.06,
    x2: 349.35,
    y2: 470.46
  })), _line394 || (_line394 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 394.66,
    y1: 479.21,
    x2: 394.66,
    y2: 455.41
  })), _line395 || (_line395 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 399.8,
    y1: 475.28,
    x2: 381.42,
    y2: 475.28
  })), _line396 || (_line396 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 399.8,
    y1: 457.27,
    x2: 381.42,
    y2: 457.27
  })), _line397 || (_line397 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 362.74,
    y1: 455.41,
    x2: 394.66,
    y2: 455.41
  })), _line398 || (_line398 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 381.42,
    y1: 475.28,
    x2: 381.42,
    y2: 457.27
  })), _line399 || (_line399 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 399.8,
    y1: 475.28,
    x2: 399.8,
    y2: 457.27
  })), _line400 || (_line400 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 353.29,
    y1: 481.58,
    x2: 353.29,
    y2: 498.86
  })), _line401 || (_line401 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 356.16,
    y1: 481.58,
    x2: 356.16,
    y2: 498.86
  })), _line402 || (_line402 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 353.89,
    y1: 540.45,
    x2: 353.89,
    y2: 533.04
  })), _line403 || (_line403 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 367.05,
    y1: 533.04,
    x2: 367.05,
    y2: 540.45
  })), _line404 || (_line404 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 453.8,
    y1: 479.21,
    x2: 421.66,
    y2: 479.21
  })), _line405 || (_line405 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 426.05,
    y1: 540.45,
    x2: 412.81,
    y2: 540.45
  })), _line406 || (_line406 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 407.14,
    y1: 514.8,
    x2: 412.81,
    y2: 519.99
  })), _line407 || (_line407 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 412.81,
    y1: 533.04,
    x2: 412.81,
    y2: 519.99
  })), _line408 || (_line408 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 457.05,
    y1: 533.04,
    x2: 412.81,
    y2: 533.04
  })), _line409 || (_line409 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 407.14,
    y1: 498.86,
    x2: 457.05,
    y2: 498.86
  })), _line410 || (_line410 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 407.14,
    y1: 514.8,
    x2: 407.14,
    y2: 498.86
  })), _line411 || (_line411 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 457.05,
    y1: 498.86,
    x2: 457.05,
    y2: 533.04
  })), _line412 || (_line412 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 419.77,
    y1: 481.58,
    x2: 408.65,
    y2: 481.58
  })), _polyline85 || (_polyline85 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "408.5 481.06 408.5 481.43 408.65 481.58"
  })), _line413 || (_line413 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 408.5,
    y1: 472.32,
    x2: 406,
    y2: 472.32
  })), _polyline86 || (_polyline86 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "419.77 481.58 419.77 481.43 419.99 481.06"
  })), _polyline87 || (_polyline87 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "408.65 470.24 408.5 470.24 408.5 470.46"
  })), _line414 || (_line414 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 408.65,
    y1: 470.24,
    x2: 419.77,
    y2: 470.24
  })), _line415 || (_line415 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 419.99,
    y1: 462.31,
    x2: 406,
    y2: 462.31
  })), _line416 || (_line416 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 419.99,
    y1: 470.46,
    x2: 419.77,
    y2: 470.24
  })), _line417 || (_line417 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 419.99,
    y1: 462.31,
    x2: 419.99,
    y2: 481.06
  })), _line418 || (_line418 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 421.66,
    y1: 479.21,
    x2: 421.66,
    y2: 455.41
  })), _line419 || (_line419 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 406,
    y1: 472.32,
    x2: 406,
    y2: 462.31
  })), _line420 || (_line420 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 408.5,
    y1: 481.06,
    x2: 408.5,
    y2: 470.46
  })), _line421 || (_line421 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 453.8,
    y1: 479.21,
    x2: 453.8,
    y2: 455.41
  })), _line422 || (_line422 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 458.72,
    y1: 475.28,
    x2: 440.42,
    y2: 475.28
  })), _line423 || (_line423 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 458.72,
    y1: 457.27,
    x2: 440.42,
    y2: 457.27
  })), _line424 || (_line424 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 421.66,
    y1: 455.41,
    x2: 453.8,
    y2: 455.41
  })), _line425 || (_line425 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 440.42,
    y1: 475.28,
    x2: 440.42,
    y2: 457.27
  })), _line426 || (_line426 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 458.72,
    y1: 475.28,
    x2: 458.72,
    y2: 457.27
  })), _line427 || (_line427 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 412.2,
    y1: 481.58,
    x2: 412.2,
    y2: 498.86
  })), _line428 || (_line428 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 415.23,
    y1: 481.58,
    x2: 415.23,
    y2: 498.86
  })), _line429 || (_line429 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 412.81,
    y1: 540.45,
    x2: 412.81,
    y2: 533.04
  })), _line430 || (_line430 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 426.05,
    y1: 533.04,
    x2: 426.05,
    y2: 540.45
  })), _line431 || (_line431 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 513.33,
    y1: 479.21,
    x2: 481.41,
    y2: 479.21
  })), _line432 || (_line432 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 485.72,
    y1: 540.45,
    x2: 472.11,
    y2: 540.45
  })), _line433 || (_line433 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 466.81,
    y1: 514.8,
    x2: 472.11,
    y2: 519.99
  })), _line434 || (_line434 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 472.11,
    y1: 533.04,
    x2: 472.11,
    y2: 519.99
  })), _line435 || (_line435 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 516.73,
    y1: 533.04,
    x2: 472.11,
    y2: 533.04
  })), _line436 || (_line436 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 466.81,
    y1: 498.86,
    x2: 516.73,
    y2: 498.86
  })), _line437 || (_line437 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 466.81,
    y1: 514.8,
    x2: 466.81,
    y2: 498.86
  })), _line438 || (_line438 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 516.73,
    y1: 498.86,
    x2: 516.73,
    y2: 533.04
  })), _line439 || (_line439 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 479.29,
    y1: 481.58,
    x2: 468.17,
    y2: 481.58
  })), _polyline88 || (_polyline88 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "467.79 481.06 467.79 481.43 468.17 481.58"
  })), _line440 || (_line440 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 467.79,
    y1: 472.32,
    x2: 465.68,
    y2: 472.32
  })), _polyline89 || (_polyline89 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "479.29 481.58 479.52 481.43 479.52 481.06"
  })), _polyline90 || (_polyline90 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "468.17 470.24 467.79 470.24 467.79 470.46"
  })), _line441 || (_line441 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 468.17,
    y1: 470.24,
    x2: 479.29,
    y2: 470.24
  })), _line442 || (_line442 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 479.52,
    y1: 462.31,
    x2: 465.68,
    y2: 462.31
  })), _polyline91 || (_polyline91 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "479.52 470.46 479.52 470.24 479.29 470.24"
  })), _line443 || (_line443 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 479.52,
    y1: 462.31,
    x2: 479.52,
    y2: 481.06
  })), _line444 || (_line444 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 481.41,
    y1: 479.21,
    x2: 481.41,
    y2: 455.41
  })), _line445 || (_line445 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 465.68,
    y1: 472.32,
    x2: 465.68,
    y2: 462.31
  })), _line446 || (_line446 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 467.79,
    y1: 481.06,
    x2: 467.79,
    y2: 470.46
  })), _line447 || (_line447 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 513.33,
    y1: 479.21,
    x2: 513.33,
    y2: 455.41
  })), _line448 || (_line448 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 518.01,
    y1: 475.28,
    x2: 500.09,
    y2: 475.28
  })), _line449 || (_line449 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 518.01,
    y1: 457.27,
    x2: 500.09,
    y2: 457.27
  })), _line450 || (_line450 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 481.41,
    y1: 455.41,
    x2: 513.33,
    y2: 455.41
  })), _line451 || (_line451 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 500.09,
    y1: 475.28,
    x2: 500.09,
    y2: 457.27
  })), _line452 || (_line452 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 518.01,
    y1: 475.28,
    x2: 518.01,
    y2: 457.27
  })), _line453 || (_line453 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 471.95,
    y1: 481.58,
    x2: 471.95,
    y2: 498.86
  })), _line454 || (_line454 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 474.6,
    y1: 481.58,
    x2: 474.6,
    y2: 498.86
  })), _line455 || (_line455 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 472.11,
    y1: 540.45,
    x2: 472.11,
    y2: 533.04
  })), _line456 || (_line456 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 485.72,
    y1: 533.04,
    x2: 485.72,
    y2: 540.45
  })), _line457 || (_line457 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 572.09,
    y1: 479.21,
    x2: 540.33,
    y2: 479.21
  })), _line458 || (_line458 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 544.71,
    y1: 540.45,
    x2: 531.48,
    y2: 540.45
  })), _line459 || (_line459 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 525.81,
    y1: 514.8,
    x2: 531.48,
    y2: 519.99
  })), _line460 || (_line460 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 531.48,
    y1: 533.04,
    x2: 531.48,
    y2: 519.99
  })), _line461 || (_line461 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 575.65,
    y1: 533.04,
    x2: 531.48,
    y2: 533.04
  })), _line462 || (_line462 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 525.81,
    y1: 498.86,
    x2: 575.65,
    y2: 498.86
  })), _line463 || (_line463 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 525.81,
    y1: 514.8,
    x2: 525.81,
    y2: 498.86
  })), _line464 || (_line464 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 575.65,
    y1: 498.86,
    x2: 575.65,
    y2: 533.04
  })), _line465 || (_line465 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 538.06,
    y1: 481.58,
    x2: 527.09,
    y2: 481.58
  })), _polyline92 || (_polyline92 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "526.71 481.06 527.09 481.43 527.09 481.58"
  })), _line466 || (_line466 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 526.71,
    y1: 472.32,
    x2: 524.67,
    y2: 472.32
  })), _polyline93 || (_polyline93 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "538.06 481.58 538.44 481.43 538.66 481.06"
  })), _line467 || (_line467 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 527.09,
    y1: 470.24,
    x2: 526.71,
    y2: 470.46
  })), _line468 || (_line468 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 527.09,
    y1: 470.24,
    x2: 538.06,
    y2: 470.24
  })), _line469 || (_line469 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 538.66,
    y1: 462.31,
    x2: 524.67,
    y2: 462.31
  })), _polyline94 || (_polyline94 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "538.66 470.46 538.44 470.24 538.06 470.24"
  })), _line470 || (_line470 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 538.66,
    y1: 462.31,
    x2: 538.66,
    y2: 481.06
  })), _line471 || (_line471 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 540.33,
    y1: 479.21,
    x2: 540.33,
    y2: 455.41
  })), _line472 || (_line472 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 524.67,
    y1: 472.32,
    x2: 524.67,
    y2: 462.31
  })), _line473 || (_line473 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 526.71,
    y1: 481.06,
    x2: 526.71,
    y2: 470.46
  })), _line474 || (_line474 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 572.09,
    y1: 479.21,
    x2: 572.09,
    y2: 455.41
  })), _line475 || (_line475 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 577.39,
    y1: 475.28,
    x2: 558.86,
    y2: 475.28
  })), _line476 || (_line476 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 577.39,
    y1: 457.27,
    x2: 558.86,
    y2: 457.27
  })), _line477 || (_line477 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 540.33,
    y1: 455.41,
    x2: 572.09,
    y2: 455.41
  })), _line478 || (_line478 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 558.86,
    y1: 475.28,
    x2: 558.86,
    y2: 457.27
  })), _line479 || (_line479 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 577.39,
    y1: 475.28,
    x2: 577.39,
    y2: 457.27
  })), _line480 || (_line480 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 530.87,
    y1: 481.58,
    x2: 530.87,
    y2: 498.86
  })), _line481 || (_line481 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 533.75,
    y1: 481.58,
    x2: 533.75,
    y2: 498.86
  })), _line482 || (_line482 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 531.48,
    y1: 540.45,
    x2: 531.48,
    y2: 533.04
  })), _line483 || (_line483 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 544.71,
    y1: 533.04,
    x2: 544.71,
    y2: 540.45
  })), _line484 || (_line484 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 631.77,
    y1: 479.21,
    x2: 599.7,
    y2: 479.21
  })), _line485 || (_line485 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 604.01,
    y1: 540.45,
    x2: 590.77,
    y2: 540.45
  })), _line486 || (_line486 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 585.1,
    y1: 514.8,
    x2: 590.77,
    y2: 519.99
  })), _line487 || (_line487 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 590.77,
    y1: 533.04,
    x2: 590.77,
    y2: 519.99
  })), _line488 || (_line488 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 635.4,
    y1: 533.04,
    x2: 590.77,
    y2: 533.04
  })), _line489 || (_line489 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 585.1,
    y1: 498.86,
    x2: 635.4,
    y2: 498.86
  })), _line490 || (_line490 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 585.1,
    y1: 514.8,
    x2: 585.1,
    y2: 498.86
  })), _line491 || (_line491 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 635.4,
    y1: 498.86,
    x2: 635.4,
    y2: 533.04
  })), _line492 || (_line492 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 597.81,
    y1: 481.58,
    x2: 586.84,
    y2: 481.58
  })), _line493 || (_line493 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 586.46,
    y1: 481.43,
    x2: 586.84,
    y2: 481.58
  })), _line494 || (_line494 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 586.46,
    y1: 472.32,
    x2: 583.97,
    y2: 472.32
  })), _polyline95 || (_polyline95 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "597.81 481.58 597.81 481.43 598.19 481.43"
  })), _polyline96 || (_polyline96 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "586.84 470.24 586.46 470.24 586.46 470.46"
  })), _line495 || (_line495 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 586.84,
    y1: 470.24,
    x2: 597.81,
    y2: 470.24
  })), _line496 || (_line496 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 598.19,
    y1: 462.46,
    x2: 583.97,
    y2: 462.46
  })), _line497 || (_line497 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 598.19,
    y1: 470.46,
    x2: 597.81,
    y2: 470.24
  })), _line498 || (_line498 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 598.19,
    y1: 462.46,
    x2: 598.19,
    y2: 481.43
  })), _line499 || (_line499 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 599.7,
    y1: 479.21,
    x2: 599.7,
    y2: 455.41
  })), _line500 || (_line500 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 583.97,
    y1: 472.32,
    x2: 583.97,
    y2: 462.46
  })), _line501 || (_line501 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 586.46,
    y1: 481.43,
    x2: 586.46,
    y2: 470.46
  })), _line502 || (_line502 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 631.77,
    y1: 479.21,
    x2: 631.77,
    y2: 455.41
  })), _line503 || (_line503 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 636.68,
    y1: 475.28,
    x2: 618.38,
    y2: 475.28
  })), _line504 || (_line504 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 636.68,
    y1: 457.27,
    x2: 618.38,
    y2: 457.27
  })), _line505 || (_line505 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 599.7,
    y1: 455.41,
    x2: 631.77,
    y2: 455.41
  })), _line506 || (_line506 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 618.38,
    y1: 475.28,
    x2: 618.38,
    y2: 457.27
  })), _line507 || (_line507 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 636.68,
    y1: 475.28,
    x2: 636.68,
    y2: 457.27
  })), _line508 || (_line508 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 590.24,
    y1: 481.58,
    x2: 590.24,
    y2: 498.86
  })), _line509 || (_line509 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 593.27,
    y1: 481.58,
    x2: 593.27,
    y2: 498.86
  })), _line510 || (_line510 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 590.77,
    y1: 540.45,
    x2: 590.77,
    y2: 533.04
  })), _line511 || (_line511 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 604.01,
    y1: 533.04,
    x2: 604.01,
    y2: 540.45
  })), _line512 || (_line512 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 690.76,
    y1: 479.21,
    x2: 658.77,
    y2: 479.21
  })), _line513 || (_line513 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 663.15,
    y1: 540.45,
    x2: 649.92,
    y2: 540.45
  })), _line514 || (_line514 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 644.25,
    y1: 514.8,
    x2: 649.92,
    y2: 519.99
  })), _line515 || (_line515 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 649.92,
    y1: 533.04,
    x2: 649.92,
    y2: 519.99
  })), _line516 || (_line516 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 694.31,
    y1: 533.04,
    x2: 649.92,
    y2: 533.04
  })), _line517 || (_line517 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 644.25,
    y1: 498.86,
    x2: 694.31,
    y2: 498.86
  })), _line518 || (_line518 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 644.25,
    y1: 514.8,
    x2: 644.25,
    y2: 498.86
  })), _line519 || (_line519 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 694.31,
    y1: 498.86,
    x2: 694.31,
    y2: 533.04
  })), _line520 || (_line520 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 656.72,
    y1: 481.58,
    x2: 645.61,
    y2: 481.58
  })), _line521 || (_line521 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 645.38,
    y1: 481.43,
    x2: 645.61,
    y2: 481.58
  })), _line522 || (_line522 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 645.38,
    y1: 472.32,
    x2: 643.34,
    y2: 472.32
  })), _line523 || (_line523 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 656.72,
    y1: 481.58,
    x2: 656.88,
    y2: 481.43
  })), _polyline97 || (_polyline97 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "645.61 470.24 645.38 470.24 645.38 470.46"
  })), _line524 || (_line524 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 645.61,
    y1: 470.24,
    x2: 656.72,
    y2: 470.24
  })), _line525 || (_line525 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 656.88,
    y1: 462.46,
    x2: 643.34,
    y2: 462.46
  })), _polyline98 || (_polyline98 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "656.88 470.46 656.88 470.24 656.72 470.24"
  })), _line526 || (_line526 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 656.88,
    y1: 462.46,
    x2: 656.88,
    y2: 481.43
  })), _line527 || (_line527 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 658.77,
    y1: 479.21,
    x2: 658.77,
    y2: 455.41
  })), _line528 || (_line528 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 643.34,
    y1: 472.32,
    x2: 643.34,
    y2: 462.46
  })), _line529 || (_line529 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 645.38,
    y1: 481.43,
    x2: 645.38,
    y2: 470.46
  })), _line530 || (_line530 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 690.76,
    y1: 479.21,
    x2: 690.76,
    y2: 455.41
  })), _line531 || (_line531 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 695.83,
    y1: 475.28,
    x2: 677.52,
    y2: 475.28
  })), _line532 || (_line532 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 695.83,
    y1: 457.27,
    x2: 677.52,
    y2: 457.27
  })), _line533 || (_line533 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 658.77,
    y1: 455.41,
    x2: 690.76,
    y2: 455.41
  })), _line534 || (_line534 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 677.52,
    y1: 475.28,
    x2: 677.52,
    y2: 457.27
  })), _line535 || (_line535 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 695.83,
    y1: 475.28,
    x2: 695.83,
    y2: 457.27
  })), _line536 || (_line536 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 649.39,
    y1: 481.58,
    x2: 649.39,
    y2: 498.86
  })), _line537 || (_line537 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 652.19,
    y1: 481.58,
    x2: 652.19,
    y2: 498.86
  })), _line538 || (_line538 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 649.92,
    y1: 540.45,
    x2: 649.92,
    y2: 533.04
  })), _line539 || (_line539 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 663.15,
    y1: 533.04,
    x2: 663.15,
    y2: 540.45
  })), _line540 || (_line540 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 750.21,
    y1: 479.21,
    x2: 718.29,
    y2: 479.21
  })), _line541 || (_line541 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 722.68,
    y1: 540.45,
    x2: 709.44,
    y2: 540.45
  })), _line542 || (_line542 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 703.77,
    y1: 514.8,
    x2: 709.44,
    y2: 519.99
  })), _line543 || (_line543 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 709.44,
    y1: 533.04,
    x2: 709.44,
    y2: 519.99
  })), _line544 || (_line544 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 753.61,
    y1: 533.04,
    x2: 709.44,
    y2: 533.04
  })), _line545 || (_line545 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 703.77,
    y1: 498.86,
    x2: 753.61,
    y2: 498.86
  })), _line546 || (_line546 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 703.77,
    y1: 514.8,
    x2: 703.77,
    y2: 498.86
  })), _line547 || (_line547 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 753.61,
    y1: 498.86,
    x2: 753.61,
    y2: 533.04
  })), _line548 || (_line548 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 716.4,
    y1: 481.58,
    x2: 705.05,
    y2: 481.58
  })), _polyline99 || (_polyline99 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "704.9 481.43 705.05 481.43 705.05 481.58"
  })), _line549 || (_line549 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 704.9,
    y1: 472.32,
    x2: 702.63,
    y2: 472.32
  })), _polyline100 || (_polyline100 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "716.4 481.58 716.4 481.43 716.63 481.43"
  })), _line550 || (_line550 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 705.05,
    y1: 470.24,
    x2: 704.9,
    y2: 470.46
  })), _line551 || (_line551 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 705.05,
    y1: 470.24,
    x2: 716.4,
    y2: 470.24
  })), _line552 || (_line552 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 716.63,
    y1: 462.46,
    x2: 702.63,
    y2: 462.46
  })), _line553 || (_line553 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 716.63,
    y1: 470.46,
    x2: 716.4,
    y2: 470.24
  })), _line554 || (_line554 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 716.63,
    y1: 462.46,
    x2: 716.63,
    y2: 481.43
  })), _line555 || (_line555 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 718.29,
    y1: 479.21,
    x2: 718.29,
    y2: 455.41
  })), _line556 || (_line556 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 702.63,
    y1: 472.32,
    x2: 702.63,
    y2: 462.46
  })), _line557 || (_line557 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 704.9,
    y1: 481.43,
    x2: 704.9,
    y2: 470.46
  })), _line558 || (_line558 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 750.21,
    y1: 479.21,
    x2: 750.21,
    y2: 455.41
  })), _line559 || (_line559 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 755.35,
    y1: 475.28,
    x2: 737.05,
    y2: 475.28
  })), _line560 || (_line560 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 755.35,
    y1: 457.27,
    x2: 737.05,
    y2: 457.27
  })), _line561 || (_line561 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 718.29,
    y1: 455.41,
    x2: 750.21,
    y2: 455.41
  })), _line562 || (_line562 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 737.05,
    y1: 475.28,
    x2: 737.05,
    y2: 457.27
  })), _line563 || (_line563 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 755.35,
    y1: 475.28,
    x2: 755.35,
    y2: 457.27
  })), _line564 || (_line564 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 708.84,
    y1: 481.58,
    x2: 708.84,
    y2: 498.86
  })), _line565 || (_line565 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 711.86,
    y1: 481.58,
    x2: 711.86,
    y2: 498.86
  })), _line566 || (_line566 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 709.44,
    y1: 540.45,
    x2: 709.44,
    y2: 533.04
  })), _line567 || (_line567 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 722.68,
    y1: 533.04,
    x2: 722.68,
    y2: 540.45
  })), _line568 || (_line568 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 809.35,
    y1: 479.21,
    x2: 777.43,
    y2: 479.21
  })), _line569 || (_line569 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 781.82,
    y1: 540.45,
    x2: 768.59,
    y2: 540.45
  })), _line570 || (_line570 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 762.91,
    y1: 514.8,
    x2: 768.36,
    y2: 519.99
  })), _line571 || (_line571 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 768.36,
    y1: 533.04,
    x2: 768.36,
    y2: 519.99
  })), _line572 || (_line572 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 812.98,
    y1: 533.04,
    x2: 768.36,
    y2: 533.04
  })), _line573 || (_line573 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 762.91,
    y1: 498.86,
    x2: 812.98,
    y2: 498.86
  })), _line574 || (_line574 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 762.91,
    y1: 514.8,
    x2: 762.91,
    y2: 498.86
  })), _line575 || (_line575 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 812.98,
    y1: 498.86,
    x2: 812.98,
    y2: 533.04
  })), _line576 || (_line576 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 775.39,
    y1: 481.58,
    x2: 764.2,
    y2: 481.58
  })), _line577 || (_line577 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 764.05,
    y1: 481.43,
    x2: 764.2,
    y2: 481.58
  })), _line578 || (_line578 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 764.05,
    y1: 472.32,
    x2: 761.78,
    y2: 472.32
  })), _line579 || (_line579 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 775.39,
    y1: 481.58,
    x2: 775.54,
    y2: 481.43
  })), _polyline101 || (_polyline101 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "764.2 470.24 764.05 470.24 764.05 470.46"
  })), _line580 || (_line580 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 764.2,
    y1: 470.24,
    x2: 775.39,
    y2: 470.24
  })), _line581 || (_line581 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 775.54,
    y1: 462.46,
    x2: 761.78,
    y2: 462.46
  })), _polyline102 || (_polyline102 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "775.54 470.46 775.54 470.24 775.39 470.24"
  })), _line582 || (_line582 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 775.54,
    y1: 462.46,
    x2: 775.54,
    y2: 481.43
  })), _line583 || (_line583 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 777.43,
    y1: 479.21,
    x2: 777.43,
    y2: 455.41
  })), _line584 || (_line584 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 761.78,
    y1: 472.32,
    x2: 761.78,
    y2: 462.46
  })), _line585 || (_line585 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 764.05,
    y1: 481.43,
    x2: 764.05,
    y2: 470.46
  })), _line586 || (_line586 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 809.35,
    y1: 479.21,
    x2: 809.35,
    y2: 455.41
  })), _line587 || (_line587 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 814.49,
    y1: 475.28,
    x2: 796.12,
    y2: 475.28
  })), _line588 || (_line588 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 814.49,
    y1: 457.27,
    x2: 796.12,
    y2: 457.27
  })), _line589 || (_line589 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 777.43,
    y1: 455.41,
    x2: 809.35,
    y2: 455.41
  })), _line590 || (_line590 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 796.12,
    y1: 475.28,
    x2: 796.12,
    y2: 457.27
  })), _line591 || (_line591 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 814.49,
    y1: 475.28,
    x2: 814.49,
    y2: 457.27
  })), _line592 || (_line592 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 767.98,
    y1: 481.58,
    x2: 767.98,
    y2: 498.86
  })), _line593 || (_line593 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 770.63,
    y1: 481.58,
    x2: 770.63,
    y2: 498.86
  })), _line594 || (_line594 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 768.59,
    y1: 540.45,
    x2: 768.59,
    y2: 533.04
  })), _line595 || (_line595 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 781.82,
    y1: 533.04,
    x2: 781.82,
    y2: 540.45
  })), _line596 || (_line596 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 868.88,
    y1: 479.21,
    x2: 836.96,
    y2: 479.21
  })), _line597 || (_line597 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 841.34,
    y1: 540.45,
    x2: 828.11,
    y2: 540.45
  })), _line598 || (_line598 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 822.44,
    y1: 514.8,
    x2: 828.11,
    y2: 519.99
  })), _line599 || (_line599 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 828.11,
    y1: 533.04,
    x2: 828.11,
    y2: 519.99
  })), _line600 || (_line600 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 872.28,
    y1: 533.04,
    x2: 828.11,
    y2: 533.04
  })), _line601 || (_line601 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 822.44,
    y1: 498.86,
    x2: 872.28,
    y2: 498.86
  })), _line602 || (_line602 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 822.44,
    y1: 514.8,
    x2: 822.44,
    y2: 498.86
  })), _line603 || (_line603 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 872.28,
    y1: 498.86,
    x2: 872.28,
    y2: 533.04
  })), _line604 || (_line604 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 834.69,
    y1: 481.58,
    x2: 823.72,
    y2: 481.58
  })), _line605 || (_line605 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 823.34,
    y1: 481.43,
    x2: 823.72,
    y2: 481.58
  })), _line606 || (_line606 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 823.34,
    y1: 472.32,
    x2: 821.3,
    y2: 472.32
  })), _line607 || (_line607 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 834.69,
    y1: 481.58,
    x2: 835.07,
    y2: 481.43
  })), _polyline103 || (_polyline103 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "823.72 470.24 823.34 470.24 823.34 470.46"
  })), _line608 || (_line608 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 823.72,
    y1: 470.24,
    x2: 834.69,
    y2: 470.24
  })), _line609 || (_line609 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 835.07,
    y1: 462.46,
    x2: 821.3,
    y2: 462.46
  })), _polyline104 || (_polyline104 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "835.07 470.46 835.07 470.24 834.69 470.24"
  })), _line610 || (_line610 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 835.07,
    y1: 462.46,
    x2: 835.07,
    y2: 481.43
  })), _line611 || (_line611 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 836.96,
    y1: 479.21,
    x2: 836.96,
    y2: 455.41
  })), _line612 || (_line612 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 821.3,
    y1: 472.32,
    x2: 821.3,
    y2: 462.46
  })), _line613 || (_line613 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 823.34,
    y1: 481.43,
    x2: 823.34,
    y2: 470.46
  })), _line614 || (_line614 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 868.88,
    y1: 479.21,
    x2: 868.88,
    y2: 455.41
  })), _line615 || (_line615 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 874.02,
    y1: 475.28,
    x2: 855.49,
    y2: 475.28
  })), _line616 || (_line616 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 874.02,
    y1: 457.27,
    x2: 855.49,
    y2: 457.27
  })), _line617 || (_line617 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 836.96,
    y1: 455.41,
    x2: 868.88,
    y2: 455.41
  })), _line618 || (_line618 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 855.49,
    y1: 475.28,
    x2: 855.49,
    y2: 457.27
  })), _line619 || (_line619 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 874.02,
    y1: 475.28,
    x2: 874.02,
    y2: 457.27
  })), _line620 || (_line620 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 827.5,
    y1: 481.58,
    x2: 827.5,
    y2: 498.86
  })), _line621 || (_line621 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 830.15,
    y1: 481.58,
    x2: 830.15,
    y2: 498.86
  })), _line622 || (_line622 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 828.11,
    y1: 540.45,
    x2: 828.11,
    y2: 533.04
  })), _line623 || (_line623 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 841.34,
    y1: 533.04,
    x2: 841.34,
    y2: 540.45
  })), _line624 || (_line624 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 928.02,
    y1: 479.21,
    x2: 896.1,
    y2: 479.21
  })), _line625 || (_line625 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 900.41,
    y1: 540.45,
    x2: 886.88,
    y2: 540.45
  })), _line626 || (_line626 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 881.58,
    y1: 514.8,
    x2: 886.88,
    y2: 519.99
  })), _line627 || (_line627 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 886.88,
    y1: 533.04,
    x2: 886.88,
    y2: 519.99
  })), _line628 || (_line628 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 931.42,
    y1: 533.04,
    x2: 886.88,
    y2: 533.04
  })), _line629 || (_line629 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 881.58,
    y1: 498.86,
    x2: 931.42,
    y2: 498.86
  })), _line630 || (_line630 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 881.58,
    y1: 514.8,
    x2: 881.58,
    y2: 498.86
  })), _line631 || (_line631 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 931.42,
    y1: 498.86,
    x2: 931.42,
    y2: 533.04
  })), _line632 || (_line632 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 893.98,
    y1: 481.58,
    x2: 882.87,
    y2: 481.58
  })), _line633 || (_line633 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 882.49,
    y1: 481.43,
    x2: 882.87,
    y2: 481.58
  })), _line634 || (_line634 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 882.49,
    y1: 472.32,
    x2: 880.45,
    y2: 472.32
  })), _line635 || (_line635 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 893.98,
    y1: 481.58,
    x2: 894.21,
    y2: 481.43
  })), _polyline105 || (_polyline105 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "882.87 470.24 882.49 470.24 882.49 470.46"
  })), _line636 || (_line636 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 882.87,
    y1: 470.24,
    x2: 893.98,
    y2: 470.24
  })), _line637 || (_line637 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 894.21,
    y1: 462.46,
    x2: 880.45,
    y2: 462.46
  })), _polyline106 || (_polyline106 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "894.21 470.46 894.21 470.24 893.98 470.24"
  })), _line638 || (_line638 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 894.21,
    y1: 462.46,
    x2: 894.21,
    y2: 481.43
  })), _line639 || (_line639 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 896.1,
    y1: 479.21,
    x2: 896.1,
    y2: 455.41
  })), _line640 || (_line640 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 880.45,
    y1: 472.32,
    x2: 880.45,
    y2: 462.46
  })), _line641 || (_line641 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 882.49,
    y1: 481.43,
    x2: 882.49,
    y2: 470.46
  })), _line642 || (_line642 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 928.02,
    y1: 479.21,
    x2: 928.02,
    y2: 455.41
  })), _line643 || (_line643 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 932.78,
    y1: 475.28,
    x2: 914.78,
    y2: 475.28
  })), _line644 || (_line644 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 932.78,
    y1: 457.27,
    x2: 914.78,
    y2: 457.27
  })), _line645 || (_line645 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 896.1,
    y1: 455.41,
    x2: 928.02,
    y2: 455.41
  })), _line646 || (_line646 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 914.78,
    y1: 475.28,
    x2: 914.78,
    y2: 457.27
  })), _line647 || (_line647 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 932.78,
    y1: 475.28,
    x2: 932.78,
    y2: 457.27
  })), _line648 || (_line648 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 886.65,
    y1: 481.58,
    x2: 886.65,
    y2: 498.86
  })), _line649 || (_line649 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 889.3,
    y1: 481.58,
    x2: 889.3,
    y2: 498.86
  })), _line650 || (_line650 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 886.88,
    y1: 540.45,
    x2: 886.88,
    y2: 533.04
  })), _line651 || (_line651 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 900.41,
    y1: 533.04,
    x2: 900.41,
    y2: 540.45
  })), _line652 || (_line652 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 473.62,
    y1: 327.52,
    x2: 505.76,
    y2: 327.52
  })), _line653 || (_line653 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 501.45,
    y1: 266.43,
    x2: 514.61,
    y2: 266.43
  })), _line654 || (_line654 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 520.28,
    y1: 292.08,
    x2: 514.61,
    y2: 286.89
  })), _line655 || (_line655 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 514.61,
    y1: 273.84,
    x2: 514.61,
    y2: 286.89
  })), _line656 || (_line656 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 470.06,
    y1: 273.84,
    x2: 514.61,
    y2: 273.84
  })), _line657 || (_line657 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 520.28,
    y1: 307.65,
    x2: 470.06,
    y2: 307.65
  })), _line658 || (_line658 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 520.28,
    y1: 292.08,
    x2: 520.28,
    y2: 307.65
  })), _line659 || (_line659 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 470.06,
    y1: 307.65,
    x2: 470.06,
    y2: 273.84
  })), _line660 || (_line660 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 507.65,
    y1: 325.3,
    x2: 518.62,
    y2: 325.3
  })), _line661 || (_line661 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 519,
    y1: 325.45,
    x2: 518.62,
    y2: 325.3
  })), _line662 || (_line662 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 519,
    y1: 334.56,
    x2: 521.42,
    y2: 334.56
  })), _polyline107 || (_polyline107 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "507.65 325.3 507.65 325.45 507.27 325.45"
  })), _polyline108 || (_polyline108 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "518.62 336.64 519 336.64 519 336.42"
  })), _line663 || (_line663 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 518.62,
    y1: 336.64,
    x2: 507.65,
    y2: 336.64
  })), _line664 || (_line664 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 507.27,
    y1: 344.2,
    x2: 521.42,
    y2: 344.2
  })), _line665 || (_line665 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 507.27,
    y1: 336.42,
    x2: 507.65,
    y2: 336.64
  })), _line666 || (_line666 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 507.27,
    y1: 344.2,
    x2: 507.27,
    y2: 325.45
  })), _line667 || (_line667 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 505.76,
    y1: 327.52,
    x2: 505.76,
    y2: 351.47
  })), _line668 || (_line668 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 521.42,
    y1: 334.56,
    x2: 521.42,
    y2: 344.2
  })), _line669 || (_line669 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 519,
    y1: 325.45,
    x2: 519,
    y2: 336.42
  })), _line670 || (_line670 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 473.62,
    y1: 327.52,
    x2: 473.62,
    y2: 351.47
  })), _line671 || (_line671 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 468.7,
    y1: 331.6,
    x2: 487.08,
    y2: 331.6
  })), _line672 || (_line672 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 468.7,
    y1: 349.61,
    x2: 487.08,
    y2: 349.61
  })), _line673 || (_line673 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 505.76,
    y1: 351.47,
    x2: 473.62,
    y2: 351.47
  })), _line674 || (_line674 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 487.08,
    y1: 331.6,
    x2: 487.08,
    y2: 349.61
  })), _line675 || (_line675 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 468.7,
    y1: 331.6,
    x2: 468.7,
    y2: 349.61
  })), _line676 || (_line676 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 515.22,
    y1: 325.3,
    x2: 515.22,
    y2: 307.65
  })), _line677 || (_line677 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 512.19,
    y1: 325.3,
    x2: 512.19,
    y2: 307.65
  })), _line678 || (_line678 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 514.61,
    y1: 266.43,
    x2: 514.61,
    y2: 273.84
  })), _line679 || (_line679 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 501.45,
    y1: 273.84,
    x2: 501.45,
    y2: 266.43
  })), _line680 || (_line680 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 532.76,
    y1: 327.52,
    x2: 564.53,
    y2: 327.52
  })), _line681 || (_line681 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 560.37,
    y1: 266.43,
    x2: 573.6,
    y2: 266.43
  })), _line682 || (_line682 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 579.28,
    y1: 292.08,
    x2: 573.76,
    y2: 286.89
  })), _line683 || (_line683 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 573.76,
    y1: 273.84,
    x2: 573.76,
    y2: 286.89
  })), _line684 || (_line684 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 529.21,
    y1: 273.84,
    x2: 573.76,
    y2: 273.84
  })), _line685 || (_line685 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 579.28,
    y1: 307.65,
    x2: 529.21,
    y2: 307.65
  })), _line686 || (_line686 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 579.28,
    y1: 292.08,
    x2: 579.28,
    y2: 307.65
  })), _line687 || (_line687 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 529.21,
    y1: 307.65,
    x2: 529.21,
    y2: 273.84
  })), _line688 || (_line688 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 566.8,
    y1: 325.3,
    x2: 577.76,
    y2: 325.3
  })), _line689 || (_line689 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 578.14,
    y1: 325.45,
    x2: 577.76,
    y2: 325.3
  })), _line690 || (_line690 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 578.14,
    y1: 334.56,
    x2: 580.18,
    y2: 334.56
  })), _line691 || (_line691 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 566.8,
    y1: 325.3,
    x2: 566.42,
    y2: 325.45
  })), _polyline109 || (_polyline109 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "577.76 336.64 578.14 336.64 578.14 336.42"
  })), _line692 || (_line692 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 577.76,
    y1: 336.64,
    x2: 566.8,
    y2: 336.64
  })), _line693 || (_line693 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 566.42,
    y1: 344.2,
    x2: 580.18,
    y2: 344.2
  })), _polyline110 || (_polyline110 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "566.42 336.42 566.42 336.64 566.8 336.64"
  })), _line694 || (_line694 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 566.42,
    y1: 344.2,
    x2: 566.42,
    y2: 325.45
  })), _line695 || (_line695 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 564.53,
    y1: 327.52,
    x2: 564.53,
    y2: 351.47
  })), _line696 || (_line696 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 580.18,
    y1: 334.56,
    x2: 580.18,
    y2: 344.2
  })), _line697 || (_line697 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 578.14,
    y1: 325.45,
    x2: 578.14,
    y2: 336.42
  })), _line698 || (_line698 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 532.76,
    y1: 327.52,
    x2: 532.76,
    y2: 351.47
  })), _line699 || (_line699 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 527.7,
    y1: 331.6,
    x2: 546,
    y2: 331.6
  })), _line700 || (_line700 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 527.7,
    y1: 349.61,
    x2: 546,
    y2: 349.61
  })), _line701 || (_line701 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 564.53,
    y1: 351.47,
    x2: 532.76,
    y2: 351.47
  })), _line702 || (_line702 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 546,
    y1: 331.6,
    x2: 546,
    y2: 349.61
  })), _line703 || (_line703 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 527.7,
    y1: 331.6,
    x2: 527.7,
    y2: 349.61
  })), _line704 || (_line704 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 573.98,
    y1: 325.3,
    x2: 573.98,
    y2: 307.65
  })), _line705 || (_line705 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 571.34,
    y1: 325.3,
    x2: 571.34,
    y2: 307.65
  })), _line706 || (_line706 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 573.6,
    y1: 266.43,
    x2: 573.6,
    y2: 273.84
  })), _line707 || (_line707 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 560.37,
    y1: 273.84,
    x2: 560.37,
    y2: 266.43
  })), _line708 || (_line708 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 592.13,
    y1: 327.52,
    x2: 624.05,
    y2: 327.52
  })), _line709 || (_line709 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 619.67,
    y1: 266.43,
    x2: 633.28,
    y2: 266.43
  })), _line710 || (_line710 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 638.57,
    y1: 292.08,
    x2: 633.28,
    y2: 286.89
  })), _line711 || (_line711 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 633.28,
    y1: 273.84,
    x2: 633.28,
    y2: 286.89
  })), _line712 || (_line712 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 588.73,
    y1: 273.84,
    x2: 633.28,
    y2: 273.84
  })), _line713 || (_line713 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 638.57,
    y1: 307.65,
    x2: 588.73,
    y2: 307.65
  })), _line714 || (_line714 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 638.57,
    y1: 292.08,
    x2: 638.57,
    y2: 307.65
  })), _line715 || (_line715 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 588.73,
    y1: 307.65,
    x2: 588.73,
    y2: 273.84
  })), _line716 || (_line716 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 626.09,
    y1: 325.3,
    x2: 637.29,
    y2: 325.3
  })), _line717 || (_line717 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 637.67,
    y1: 325.45,
    x2: 637.29,
    y2: 325.3
  })), _line718 || (_line718 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 637.67,
    y1: 334.56,
    x2: 639.71,
    y2: 334.56
  })), _line719 || (_line719 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 626.09,
    y1: 325.3,
    x2: 625.94,
    y2: 325.45
  })), _polyline111 || (_polyline111 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "637.29 336.64 637.67 336.64 637.67 336.42"
  })), _line720 || (_line720 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 637.29,
    y1: 336.64,
    x2: 626.09,
    y2: 336.64
  })), _line721 || (_line721 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 625.94,
    y1: 344.2,
    x2: 639.71,
    y2: 344.2
  })), _polyline112 || (_polyline112 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "625.94 336.42 625.94 336.64 626.09 336.64"
  })), _line722 || (_line722 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 625.94,
    y1: 344.2,
    x2: 625.94,
    y2: 325.45
  })), _line723 || (_line723 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 624.05,
    y1: 327.52,
    x2: 624.05,
    y2: 351.47
  })), _line724 || (_line724 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 639.71,
    y1: 334.56,
    x2: 639.71,
    y2: 344.2
  })), _line725 || (_line725 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 637.67,
    y1: 325.45,
    x2: 637.67,
    y2: 336.42
  })), _line726 || (_line726 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 592.13,
    y1: 327.52,
    x2: 592.13,
    y2: 351.47
  })), _line727 || (_line727 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 587.37,
    y1: 331.6,
    x2: 605.29,
    y2: 331.6
  })), _line728 || (_line728 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 587.37,
    y1: 349.61,
    x2: 605.29,
    y2: 349.61
  })), _line729 || (_line729 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 624.05,
    y1: 351.47,
    x2: 592.13,
    y2: 351.47
  })), _line730 || (_line730 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 605.29,
    y1: 331.6,
    x2: 605.29,
    y2: 349.61
  })), _line731 || (_line731 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 587.37,
    y1: 331.6,
    x2: 587.37,
    y2: 349.61
  })), _line732 || (_line732 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 633.51,
    y1: 325.3,
    x2: 633.51,
    y2: 307.65
  })), _line733 || (_line733 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 630.86,
    y1: 325.3,
    x2: 630.86,
    y2: 307.65
  })), _line734 || (_line734 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 633.28,
    y1: 266.43,
    x2: 633.28,
    y2: 273.84
  })), _line735 || (_line735 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 619.67,
    y1: 273.84,
    x2: 619.67,
    y2: 266.43
  })), _line736 || (_line736 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 651.28,
    y1: 327.52,
    x2: 683.2,
    y2: 327.52
  })), _line737 || (_line737 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 678.81,
    y1: 266.43,
    x2: 692.05,
    y2: 266.43
  })), _line738 || (_line738 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.72,
    y1: 292.08,
    x2: 692.05,
    y2: 286.89
  })), _line739 || (_line739 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 692.05,
    y1: 273.84,
    x2: 692.05,
    y2: 286.89
  })), _line740 || (_line740 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 647.88,
    y1: 273.84,
    x2: 692.05,
    y2: 273.84
  })), _line741 || (_line741 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.72,
    y1: 307.65,
    x2: 647.88,
    y2: 307.65
  })), _line742 || (_line742 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 697.72,
    y1: 292.08,
    x2: 697.72,
    y2: 307.65
  })), _line743 || (_line743 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 647.88,
    y1: 307.65,
    x2: 647.88,
    y2: 273.84
  })), _line744 || (_line744 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 685.47,
    y1: 325.3,
    x2: 696.43,
    y2: 325.3
  })), _line745 || (_line745 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 696.81,
    y1: 325.45,
    x2: 696.43,
    y2: 325.3
  })), _line746 || (_line746 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 696.81,
    y1: 334.56,
    x2: 698.85,
    y2: 334.56
  })), _line747 || (_line747 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 685.47,
    y1: 325.3,
    x2: 685.09,
    y2: 325.45
  })), _polyline113 || (_polyline113 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "696.43 336.64 696.81 336.64 696.81 336.42"
  })), _line748 || (_line748 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 696.43,
    y1: 336.64,
    x2: 685.47,
    y2: 336.64
  })), _line749 || (_line749 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 685.09,
    y1: 344.2,
    x2: 698.85,
    y2: 344.2
  })), _polyline114 || (_polyline114 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "685.09 336.42 685.09 336.64 685.47 336.64"
  })), _line750 || (_line750 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 685.09,
    y1: 344.2,
    x2: 685.09,
    y2: 325.45
  })), _line751 || (_line751 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 683.2,
    y1: 327.52,
    x2: 683.2,
    y2: 351.47
  })), _line752 || (_line752 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 698.85,
    y1: 334.56,
    x2: 698.85,
    y2: 344.2
  })), _line753 || (_line753 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 696.81,
    y1: 325.45,
    x2: 696.81,
    y2: 336.42
  })), _line754 || (_line754 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 651.28,
    y1: 327.52,
    x2: 651.28,
    y2: 351.47
  })), _line755 || (_line755 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 646.14,
    y1: 331.6,
    x2: 664.44,
    y2: 331.6
  })), _line756 || (_line756 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 646.14,
    y1: 349.61,
    x2: 664.44,
    y2: 349.61
  })), _line757 || (_line757 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 683.2,
    y1: 351.47,
    x2: 651.28,
    y2: 351.47
  })), _line758 || (_line758 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 664.44,
    y1: 331.6,
    x2: 664.44,
    y2: 349.61
  })), _line759 || (_line759 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 646.14,
    y1: 331.6,
    x2: 646.14,
    y2: 349.61
  })), _line760 || (_line760 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 692.65,
    y1: 325.3,
    x2: 692.65,
    y2: 307.65
  })), _line761 || (_line761 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 690,
    y1: 325.3,
    x2: 690,
    y2: 307.65
  })), _line762 || (_line762 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 692.05,
    y1: 266.43,
    x2: 692.05,
    y2: 273.84
  })), _line763 || (_line763 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 678.81,
    y1: 273.84,
    x2: 678.81,
    y2: 266.43
  })), _line764 || (_line764 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 710.73,
    y1: 327.52,
    x2: 742.72,
    y2: 327.52
  })), _line765 || (_line765 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 738.33,
    y1: 266.43,
    x2: 751.57,
    y2: 266.43
  })), _line766 || (_line766 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 757.24,
    y1: 292.08,
    x2: 751.72,
    y2: 286.89
  })), _line767 || (_line767 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 751.72,
    y1: 273.84,
    x2: 751.72,
    y2: 286.89
  })), _line768 || (_line768 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 707.17,
    y1: 273.84,
    x2: 751.72,
    y2: 273.84
  })), _line769 || (_line769 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 757.24,
    y1: 307.65,
    x2: 707.17,
    y2: 307.65
  })), _line770 || (_line770 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 757.24,
    y1: 292.08,
    x2: 757.24,
    y2: 307.65
  })), _line771 || (_line771 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 707.17,
    y1: 307.65,
    x2: 707.17,
    y2: 273.84
  })), _line772 || (_line772 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 744.76,
    y1: 325.3,
    x2: 755.88,
    y2: 325.3
  })), _line773 || (_line773 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 756.11,
    y1: 325.45,
    x2: 755.88,
    y2: 325.3
  })), _line774 || (_line774 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 756.11,
    y1: 334.56,
    x2: 758.38,
    y2: 334.56
  })), _line775 || (_line775 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 744.76,
    y1: 325.3,
    x2: 744.61,
    y2: 325.45
  })), _polyline115 || (_polyline115 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "755.88 336.64 756.11 336.64 756.11 336.42"
  })), _line776 || (_line776 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 755.88,
    y1: 336.64,
    x2: 744.76,
    y2: 336.64
  })), _line777 || (_line777 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 744.61,
    y1: 344.2,
    x2: 758.38,
    y2: 344.2
  })), _polyline116 || (_polyline116 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "744.61 336.42 744.61 336.64 744.76 336.64"
  })), _line778 || (_line778 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 744.61,
    y1: 344.2,
    x2: 744.61,
    y2: 325.45
  })), _line779 || (_line779 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 742.72,
    y1: 327.52,
    x2: 742.72,
    y2: 351.47
  })), _line780 || (_line780 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 758.38,
    y1: 334.56,
    x2: 758.38,
    y2: 344.2
  })), _line781 || (_line781 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 756.11,
    y1: 325.45,
    x2: 756.11,
    y2: 336.42
  })), _line782 || (_line782 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 710.73,
    y1: 327.52,
    x2: 710.73,
    y2: 351.47
  })), _line783 || (_line783 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 705.66,
    y1: 331.6,
    x2: 723.96,
    y2: 331.6
  })), _line784 || (_line784 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 705.66,
    y1: 349.61,
    x2: 723.96,
    y2: 349.61
  })), _line785 || (_line785 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 742.72,
    y1: 351.47,
    x2: 710.73,
    y2: 351.47
  })), _line786 || (_line786 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 723.96,
    y1: 331.6,
    x2: 723.96,
    y2: 349.61
  })), _line787 || (_line787 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 705.66,
    y1: 331.6,
    x2: 705.66,
    y2: 349.61
  })), _line788 || (_line788 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 752.1,
    y1: 325.3,
    x2: 752.1,
    y2: 307.65
  })), _line789 || (_line789 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 749.45,
    y1: 325.3,
    x2: 749.45,
    y2: 307.65
  })), _line790 || (_line790 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 751.57,
    y1: 266.43,
    x2: 751.57,
    y2: 273.84
  })), _line791 || (_line791 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 738.33,
    y1: 273.84,
    x2: 738.33,
    y2: 266.43
  })), _line792 || (_line792 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 769.87,
    y1: 327.52,
    x2: 801.79,
    y2: 327.52
  })), _line793 || (_line793 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 797.48,
    y1: 266.43,
    x2: 810.71,
    y2: 266.43
  })), _line794 || (_line794 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 816.39,
    y1: 292.08,
    x2: 810.71,
    y2: 286.89
  })), _line795 || (_line795 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 810.71,
    y1: 273.84,
    x2: 810.71,
    y2: 286.89
  })), _line796 || (_line796 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 766.47,
    y1: 273.84,
    x2: 810.71,
    y2: 273.84
  })), _line797 || (_line797 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 816.39,
    y1: 307.65,
    x2: 766.47,
    y2: 307.65
  })), _line798 || (_line798 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 816.39,
    y1: 292.08,
    x2: 816.39,
    y2: 307.65
  })), _line799 || (_line799 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 766.47,
    y1: 307.65,
    x2: 766.47,
    y2: 273.84
  })), _line800 || (_line800 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 803.68,
    y1: 325.3,
    x2: 815.02,
    y2: 325.3
  })), _polyline117 || (_polyline117 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "815.25 325.45 815.02 325.45 815.02 325.3"
  })), _line801 || (_line801 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 815.25,
    y1: 334.56,
    x2: 817.52,
    y2: 334.56
  })), _polyline118 || (_polyline118 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "803.68 325.3 803.68 325.45 803.3 325.45"
  })), _line802 || (_line802 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 815.02,
    y1: 336.64,
    x2: 815.25,
    y2: 336.42
  })), _line803 || (_line803 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 815.02,
    y1: 336.64,
    x2: 803.68,
    y2: 336.64
  })), _line804 || (_line804 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 803.3,
    y1: 344.2,
    x2: 817.52,
    y2: 344.2
  })), _line805 || (_line805 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 803.3,
    y1: 336.42,
    x2: 803.68,
    y2: 336.64
  })), _line806 || (_line806 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 803.3,
    y1: 344.2,
    x2: 803.3,
    y2: 325.45
  })), _line807 || (_line807 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 801.79,
    y1: 327.52,
    x2: 801.79,
    y2: 351.47
  })), _line808 || (_line808 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 817.52,
    y1: 334.56,
    x2: 817.52,
    y2: 344.2
  })), _line809 || (_line809 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 815.25,
    y1: 325.45,
    x2: 815.25,
    y2: 336.42
  })), _line810 || (_line810 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 769.87,
    y1: 327.52,
    x2: 769.87,
    y2: 351.47
  })), _line811 || (_line811 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 764.8,
    y1: 331.6,
    x2: 783.11,
    y2: 331.6
  })), _line812 || (_line812 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 764.8,
    y1: 349.61,
    x2: 783.11,
    y2: 349.61
  })), _line813 || (_line813 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 801.79,
    y1: 351.47,
    x2: 769.87,
    y2: 351.47
  })), _line814 || (_line814 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 783.11,
    y1: 331.6,
    x2: 783.11,
    y2: 349.61
  })), _line815 || (_line815 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 764.8,
    y1: 331.6,
    x2: 764.8,
    y2: 349.61
  })), _line816 || (_line816 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 811.24,
    y1: 325.3,
    x2: 811.24,
    y2: 307.65
  })), _line817 || (_line817 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 808.22,
    y1: 325.3,
    x2: 808.22,
    y2: 307.65
  })), _line818 || (_line818 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 810.71,
    y1: 266.43,
    x2: 810.71,
    y2: 273.84
  })), _line819 || (_line819 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 797.48,
    y1: 273.84,
    x2: 797.48,
    y2: 266.43
  })), _line820 || (_line820 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 829.39,
    y1: 327.52,
    x2: 861.16,
    y2: 327.52
  })), _line821 || (_line821 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 857,
    y1: 266.43,
    x2: 870.24,
    y2: 266.43
  })), _line822 || (_line822 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 875.91,
    y1: 292.08,
    x2: 870.24,
    y2: 286.89
  })), _line823 || (_line823 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 870.24,
    y1: 273.84,
    x2: 870.24,
    y2: 286.89
  })), _line824 || (_line824 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 825.84,
    y1: 273.84,
    x2: 870.24,
    y2: 273.84
  })), _line825 || (_line825 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 875.91,
    y1: 307.65,
    x2: 825.84,
    y2: 307.65
  })), _line826 || (_line826 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 875.91,
    y1: 292.08,
    x2: 875.91,
    y2: 307.65
  })), _line827 || (_line827 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 825.84,
    y1: 307.65,
    x2: 825.84,
    y2: 273.84
  })), _line828 || (_line828 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 863.43,
    y1: 325.3,
    x2: 874.55,
    y2: 325.3
  })), _line829 || (_line829 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 874.77,
    y1: 325.45,
    x2: 874.55,
    y2: 325.3
  })), _line830 || (_line830 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 874.77,
    y1: 334.56,
    x2: 876.82,
    y2: 334.56
  })), _line831 || (_line831 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 863.43,
    y1: 325.3,
    x2: 863.2,
    y2: 325.45
  })), _polyline119 || (_polyline119 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "874.55 336.64 874.77 336.64 874.77 336.42"
  })), _line832 || (_line832 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 874.55,
    y1: 336.64,
    x2: 863.43,
    y2: 336.64
  })), _line833 || (_line833 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 863.2,
    y1: 344.2,
    x2: 876.82,
    y2: 344.2
  })), _polyline120 || (_polyline120 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "863.2 336.42 863.2 336.64 863.43 336.64"
  })), _line834 || (_line834 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 863.2,
    y1: 344.2,
    x2: 863.2,
    y2: 325.45
  })), _line835 || (_line835 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 861.16,
    y1: 327.52,
    x2: 861.16,
    y2: 351.47
  })), _line836 || (_line836 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 876.82,
    y1: 334.56,
    x2: 876.82,
    y2: 344.2
  })), _line837 || (_line837 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 874.77,
    y1: 325.45,
    x2: 874.77,
    y2: 336.42
  })), _line838 || (_line838 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 829.39,
    y1: 327.52,
    x2: 829.39,
    y2: 351.47
  })), _line839 || (_line839 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 824.33,
    y1: 331.6,
    x2: 842.63,
    y2: 331.6
  })), _line840 || (_line840 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 824.33,
    y1: 349.61,
    x2: 842.63,
    y2: 349.61
  })), _line841 || (_line841 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 861.16,
    y1: 351.47,
    x2: 829.39,
    y2: 351.47
  })), _line842 || (_line842 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 842.63,
    y1: 331.6,
    x2: 842.63,
    y2: 349.61
  })), _line843 || (_line843 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 824.33,
    y1: 331.6,
    x2: 824.33,
    y2: 349.61
  })), _line844 || (_line844 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 870.77,
    y1: 325.3,
    x2: 870.77,
    y2: 307.65
  })), _line845 || (_line845 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 867.97,
    y1: 325.3,
    x2: 867.97,
    y2: 307.65
  })), _line846 || (_line846 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 870.24,
    y1: 266.43,
    x2: 870.24,
    y2: 273.84
  })), _line847 || (_line847 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 857,
    y1: 273.84,
    x2: 857,
    y2: 266.43
  })), _line848 || (_line848 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 888.16,
    y1: 327.52,
    x2: 920.46,
    y2: 327.52
  })), _line849 || (_line849 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 916.15,
    y1: 266.43,
    x2: 929.38,
    y2: 266.43
  })), _line850 || (_line850 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 935.05,
    y1: 292.08,
    x2: 929.38,
    y2: 286.89
  })), _line851 || (_line851 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 929.38,
    y1: 273.84,
    x2: 929.38,
    y2: 286.89
  })), _line852 || (_line852 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 884.76,
    y1: 273.84,
    x2: 929.38,
    y2: 273.84
  })), _line853 || (_line853 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 935.05,
    y1: 307.65,
    x2: 884.76,
    y2: 307.65
  })), _line854 || (_line854 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 935.05,
    y1: 292.08,
    x2: 935.05,
    y2: 307.65
  })), _line855 || (_line855 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 884.76,
    y1: 307.65,
    x2: 884.76,
    y2: 273.84
  })), _line856 || (_line856 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 922.35,
    y1: 325.3,
    x2: 933.31,
    y2: 325.3
  })), _line857 || (_line857 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 933.69,
    y1: 325.45,
    x2: 933.31,
    y2: 325.3
  })), _line858 || (_line858 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 933.69,
    y1: 334.56,
    x2: 936.19,
    y2: 334.56
  })), _polyline121 || (_polyline121 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "922.35 325.3 922.35 325.45 921.97 325.45"
  })), _polyline122 || (_polyline122 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "933.31 336.64 933.69 336.64 933.69 336.42"
  })), _line859 || (_line859 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 933.31,
    y1: 336.64,
    x2: 922.35,
    y2: 336.64
  })), _line860 || (_line860 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 921.97,
    y1: 344.2,
    x2: 936.19,
    y2: 344.2
  })), _line861 || (_line861 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 921.97,
    y1: 336.42,
    x2: 922.35,
    y2: 336.64
  })), _line862 || (_line862 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 921.97,
    y1: 344.2,
    x2: 921.97,
    y2: 325.45
  })), _line863 || (_line863 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 920.46,
    y1: 327.52,
    x2: 920.46,
    y2: 351.47
  })), _line864 || (_line864 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 936.19,
    y1: 334.56,
    x2: 936.19,
    y2: 344.2
  })), _line865 || (_line865 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 933.69,
    y1: 325.45,
    x2: 933.69,
    y2: 336.42
  })), _line866 || (_line866 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 888.16,
    y1: 327.52,
    x2: 888.16,
    y2: 351.47
  })), _line867 || (_line867 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 883.47,
    y1: 331.6,
    x2: 901.77,
    y2: 331.6
  })), _line868 || (_line868 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 883.47,
    y1: 349.61,
    x2: 901.77,
    y2: 349.61
  })), _line869 || (_line869 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 920.46,
    y1: 351.47,
    x2: 888.16,
    y2: 351.47
  })), _line870 || (_line870 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 901.77,
    y1: 331.6,
    x2: 901.77,
    y2: 349.61
  })), _line871 || (_line871 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 883.47,
    y1: 331.6,
    x2: 883.47,
    y2: 349.61
  })), _line872 || (_line872 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 929.91,
    y1: 325.3,
    x2: 929.91,
    y2: 307.65
  })), _line873 || (_line873 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 926.89,
    y1: 325.3,
    x2: 926.89,
    y2: 307.65
  })), _line874 || (_line874 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 929.38,
    y1: 266.43,
    x2: 929.38,
    y2: 273.84
  })), _line875 || (_line875 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 916.15,
    y1: 273.84,
    x2: 916.15,
    y2: 266.43
  })), _line876 || (_line876 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 451.76,
    y1: 273.84,
    x2: 451.76,
    y2: 266.06
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 210.6,
    y: 555.69,
    width: 798.6,
    height: 64.24
  })), _line877 || (_line877 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 213.29,
    y1: 310.37,
    x2: 967.8,
    y2: 310.37
  })), _line878 || (_line878 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 209.21,
    y1: 493.3,
    x2: 963.72,
    y2: 493.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamiMapsCpSubArea1);
export default __webpack_public_path__ + "static/media/NAMI Maps_CP Sub Area 1.78463a7f708cac800e7163e9b67c6d74.svg";
export { ForwardRef as ReactComponent };